<template>
    <div :class="dialogOnly ? '' : 'sarai-bookings-page p-6'">


        <div v-if="!dialogOnly" class="vx-row">

            <!-- Left Column: Bookings List -->
            <div class="vx-col w-full lg:w-2/3">
                <vs-card>
                    <div class="p-4">
                        <!-- Header -->
                        <div class="flex flex-wrap items-center justify-between mb-6">
                            <div class="flex items-center">
                                <vs-button icon-pack="feather" icon="icon-arrow-left" class="mr-4" color="dark"
                                    @click="goBackToSaraiDetails">
                                    Back
                                </vs-button>
                                <h2 class="text-2xl font-bold">Sarai Bookings</h2>
                            </div>
                            <div>
                                <vs-button
                                  v-if="canShowNewBooking"
                                  color="dark"
                                  icon-pack="feather"
                                  icon="icon-plus"
                                  @click="openNewBookingModal"
                                >
                                    New Booking
                                </vs-button>
                            </div>
                        </div>
                        <vs-tabs v-model="activeTab" class="booking-tabs">
                            <vs-tab v-for="status in ['pending', 'confirmed', 'rejected', 'cancelled', 'refunded']"
                                :key="status"
                                :label="`${status.charAt(0).toUpperCase() + status.slice(1)} (${totalCounts[status]})`">
                                <div class="mt-4 booking-list-scroll">
                                    <div v-if="loading" class="p-4 text-center">Loading...</div>
                                    <div v-else-if="!bookings[status] || bookings[status].length === 0"
                                        class="p-4 text-center text-gray-500">No bookings found</div>
                                    <div v-else v-for="booking in bookings[status]" :key="booking._id"
                                        class="booking-card p-5 mb-4 relative"
                                        :class="{ 'is-new-booking': isHighlightedBooking(booking) }">
                                        <div class="ml-2">
                                            <!-- Top Row Info -->
                                            <div class="flex items-center justify-between mb-3">
                                                <div class="flex items-center" style="gap: 10px">
                                                    <span class="tag booking-type-tag">Sarai</span>
                                                    <span v-if="getBookingDisplayStatus(booking) === 'pending'" class="tag new-booking-tag">New</span>
                                                    <span class="bg-black text-white rounded cursor-default"
                                                        style="font-size: 17px; padding:5px 10px;">
                                                        {{ booking.dateRange }} · {{ booking.amount }}
                                                    </span>
                                                    <span
                                                        v-if="getBookingDisplayStatus(booking) === 'rejected'"
                                                        class="tag danger">Rejected</span>
                                                    <span
                                                        v-else-if="getBookingDisplayStatus(booking) === 'cancelled'"
                                                        class="tag danger">Cancelled</span>
                                                    <span
                                                        v-else-if="getBookingDisplayStatus(booking) === 'refunded'"
                                                        class="tag warning">Refunded</span>
                                                    <span
                                                        v-else-if="getBookingDisplayStatus(booking) === 'pending'"
                                                        class="tag warning">Pending</span>
                                                    <span
                                                        v-else-if="getBookingDisplayStatus(booking) === 'confirmed'"
                                                        class="tag success">Confirmed</span>

                                                </div>
                                                <button class="view_details" type="filled"
                                                    @click.stop="openDetailPanel(booking)">
                                                    <p class="flex items-center text-base m-0">
                                                        <span class="whitespace-no-wrap font-bold text-black">
                                                            View Details
                                                        </span>
                                                        <feather-icon icon="ChevronRightIcon"
                                                            svgClasses="h-6 w-6 text-black" />
                                                    </p>
                                                </button>
                                            </div>

                                            <!-- User Name -->
                                            <h3 class="user-name capitalize mt-5">{{ booking.userName }}</h3>

                                            <!-- Details Grid -->
                                            <div class="vx-row my-4 booking-info-grid">
                                                <div v-if="booking.sangatId && booking.sangatId !== '-'"
                                                    class="vx-col w-1/3">
                                                    <span class="info-label">Sangat ID</span>
                                                    <div class="info-value-with-icon">
                                                        <span>
                                                            {{ booking.sangatId }}
                                                        </span>
                                                        <feather-icon icon="CopyIcon" svgClasses="h-6 w-6 copy-icon"
                                                            @click="copyToClipboard(booking.sangatId)" />
                                                    </div>
                                                </div>
                                                <div v-if="booking.email && booking.email !== '-'" class="vx-col w-1/3">
                                                    <span class="info-label">Email</span>
                                                    <div class="info-value-with-icon">
                                                        <span>
                                                            {{ booking.email }}
                                                        </span>
                                                        <feather-icon icon="CopyIcon" svgClasses="h-6 w-6 copy-icon"
                                                            @click="copyToClipboard(booking.email)" />
                                                    </div>
                                                </div>
                                                <div v-if="booking.phone && booking.phone !== '-'" class="vx-col w-1/3">
                                                    <span class="info-label">Phone</span>
                                                    <div class="info-value-with-icons">
                                                        <span>
                                                            {{ booking.phone }}
                                                        </span>
                                                        <feather-icon icon="CopyIcon" svgClasses="h-6 w-6 copy-icon"
                                                            @click="copyToClipboard(booking.phone)" />
                                                        <a v-if="booking.phone && booking.phone !== '-'"
                                                            :href="`https://wa.me/${booking.phone.replace(/[^0-9]/g, '')}`"
                                                            target="_blank" class="ml-2">
                                                            <feather-icon icon="MessageCircleIcon"
                                                                svgClasses="h-6 w-6 whatsapp-icon" />
                                                        </a>

                                                    </div>
                                                </div>
                                            </div>

                                            <div class="vx-row mb-6">
                                                <div class="vx-col w-1/3">
                                                    <span class="info-label">Booking Date & Time</span>
                                                    <div class="info-value">
                                                        {{ booking.bookingDate }}
                                                    </div>
                                                </div>
                                                <div class="vx-col w-1/3">
                                                    <span class="info-label">Booking ID</span>
                                                    <div class="info-value-with-icon">
                                                        <span>


                                                            {{ booking.bookingId }}
                                                        </span>
                                                        <feather-icon icon="CopyIcon" svgClasses="h-6 w-6 copy-icon"
                                                            @click="copyToClipboard(booking.bookingId)" />
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Footer / Sarai Info -->
                                            <div class="pt-4 flex items-center"
                                                style="border-top: 1px solid #CCCCCCE5;">
                                                <div class="w-12 h-12 rounded overflow-hidden mr-3 bg-gray-200">
                                                    <img v-if="booking.image" :src="booking.image"
                                                        class="w-full h-full object-cover">
                                                </div>
                                                <div>
                                                    <h4 class="font-bold" style="font-size:15px; ">{{ booking.saraiName
                                                        }}</h4>
                                                    <p class=" text-gray-500 mt-1 text-base">{{ booking.location }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </vs-tab>
                        </vs-tabs>
                    </div>
                </vs-card>
            </div>

            <!-- Right Column: Filters -->
            <div class="vx-col w-full lg:w-1/3 mb-base" style="height: calc(100vh - 100px);">
                <vs-card class="h-full">
                    <div class="p-4 filters-panel">
                        <h3 class="text-xl font-bold mb-6">Filters</h3>

                        <!-- Sarai Name Filter -->
                        <div class="mb-6">
                            <label class="text-lg font-bold mb-2 block">Sarai Name</label>
                            <select-2 :key="'filter-sarai-' + filterResetKey" class="w-full" :name="'filter-sarai'"
                                placeholder="Select Sarai" :options="saraiOptions"
                                :extra="[{ label: 'All Sarai', value: null }]" :multiple="false"
                                :value="filterSarai" @input="(item) => (filterSarai = item && item.value)" />
                        </div>

                        <!-- Sangat App User Filter -->
                        <div class="mb-6">
                            <label class="text-lg font-bold mb-2 block">Sangat App User</label>
                            <select-2 :key="'filter-user-' + filterResetKey" class="w-full" :name="'filter-user'"
                                placeholder="User name or handle name" action="user/get" :ssr="true"
                                :params="userSearchParams" :multiple="false" :value="filterUser" data-vv-as="User"
                                @input="(item) => (filterUser = item && item.value)" />
                        </div>

                        <!-- Date Filter -->
                        <div class="mb-6">
                            <p class="text-lg font-bold mb-2">Date</p>
                            <flat-pickr :key="'filter-date-' + filterResetKey" v-model="filterDate" :config="dateConfig"
                                class="w-full" placeholder="Select Date" />
                        </div>

                        <vs-button class="w-full" color="dark" size="large" text-color="white"
                            :disabled="!hasActiveFilters" @click="clearFilters">
                            Clear Filters
                        </vs-button>
                    </div>
                </vs-card>
            </div>
        </div>

        <!-- User Details Modal (First Modal) -->
        <div v-if="showNewBookingModal && !isNewBookingMinimized" class="detail-panel-overlay"
            @click="closeNewBookingModal">
            <div class="detail-panel" @click.stop>
                <div class="panel-header items-center justify-between px-6">
                    <div class="panel-title">
                        <h3>New Sarai Booking</h3>
                    </div>
                    <div class="panel-controls">
                        <feather-icon icon="Maximize2Icon" svgClasses="h-6 w-6 text-black cursor-pointer"
                            title="Collapse panel" @click.stop="toggleNewBookingMinimize" />
                        <feather-icon icon="XIcon" svgClasses="h-6 w-6 text-black cursor-pointer"
                            @click.stop="closeNewBookingModal" />
                    </div>
                </div>
                <div class="panel-content scrollable-modal-body px-5">
                    <!-- Booking For -->
                    <div class="py-6" style="border-top: 1px solid #d1d5db; border-bottom: 1px solid #d1d5db;">
                        <p class="text-2xl text-black font-bold pb-2">Booking For:</p>
                        <label class="vs-input--label">Enter Sangat User Handle Name *</label>
                        <select-2 :key="'new-booking-user-select'" class="w-full" :name="'new-booking-user'"
                            placeholder="Enter Sangat User Handle Name here" action="user/get" :ssr="true"
                            :params="userSearchParams" :multiple="false" :value="newBooking.userId" data-vv-as="User"
                            @input="(item) => (newBooking.userId = item && item.value)" />
                    </div>

                    <!-- Check-in & check-out dates -->
                    <div class="form-section mt-5">
                        <h4 class="section-title">Check-in & check-out dates</h4>
                        <flat-pickr v-model="newBooking.dateRange" :config="dateRangeConfig"
                            class="w-full border p-3 rounded" placeholder="Select date" />
                    </div>

                    <!-- Number of guests -->
                    <div class="form-section">
                        <h4 class="section-title">Number of guests</h4>

                        <div class="guest-counter-item">
                            <div>
                                <div class="font-semibold text-base">Adults</div>
                                <div class="text-sm text-gray-500">Age 18 and above</div>
                            </div>
                            <div class="counter-controls">
                                <vs-button size="small" color="dark" type="border" icon="remove"
                                    @click="decrementGuest('adults')"></vs-button>
                                <span class="counter-value">{{ newBooking.guests.adults }}</span>
                                <vs-button size="small" color="dark" type="border" icon="add"
                                    @click="incrementGuest('adults')"></vs-button>
                            </div>
                        </div>

                        <div class="guest-counter-item">
                            <div>
                                <div class="font-semibold text-base">Children</div>
                                <div class="text-sm text-gray-500">Ages 2–12</div>
                            </div>
                            <div class="counter-controls">
                                <vs-button size="small" color="dark" type="border" icon="remove"
                                    @click="decrementGuest('children')"></vs-button>
                                <span class="counter-value">{{ newBooking.guests.children }}</span>
                                <vs-button size="small" color="dark" type="border" icon="add"
                                    @click="incrementGuest('children')"></vs-button>
                            </div>
                        </div>

                        <div class="guest-counter-item">
                            <div>
                                <div class="font-semibold text-base">Infants</div>
                                <div class="text-sm text-gray-500">Under 2</div>
                            </div>
                            <div class="counter-controls">
                                <vs-button size="small" color="dark" type="border" icon="remove"
                                    @click="decrementGuest('infants')"></vs-button>
                                <span class="counter-value">{{ newBooking.guests.infants }}</span>
                                <vs-button size="small" color="dark" type="border" icon="add"
                                    @click="incrementGuest('infants')"></vs-button>
                            </div>
                        </div>

                        <div class="guest-counter-item">
                            <div>
                                <div class="font-semibold text-base">Pets</div>
                                <div class="text-sm text-gray-500">Service animals allowed</div>
                            </div>
                            <div class="counter-controls">
                                <vs-button size="small" color="dark" type="border" icon="remove"
                                    @click="decrementGuest('pets')"></vs-button>
                                <span class="counter-value">{{ newBooking.guests.pets }}</span>
                                <vs-button size="small" color="dark" type="border" icon="add"
                                    @click="incrementGuest('pets')"></vs-button>
                            </div>
                        </div>
                    </div>

                    <!-- Collect Documents -->
                    <div class="form-section collect-documents-section">
                        <div class="flex items-center justify-between">
                            <h4 class="section-title mb-0">Collect Documents?</h4>
                            <vs-switch v-model="newBooking.collectDocuments" color="dark" />
                        </div>
                    </div>

                    <!-- Document Collection Section -->
                    <div v-if="newBooking.collectDocuments" class="form-section">
                        <h4 class="mb-4 text-lg font-bold text-black">Documents</h4>
                        <div class="documents-grid-new-booking">
                            <div v-for="(doc, idx) in newBooking.documents" :key="`booking-doc-${idx}`"
                                class="document-card-new-booking" @click="handleDocCardClick(idx, $event)">
                                <div class="new-document-content">
                                    <div class="new-doc-left">
                                        <div v-if="!doc.isEditing" class="new-doc-info">
                                            <h5 class="document-title">{{ doc.document_name || 'New Document' }}</h5>
                                            <p class="new-doc-requirement">{{ doc.isRequired ? 'Required' : 'Optional'
                                            }}</p>
                                            <p v-if="doc.uploadHint" class="new-doc-hint">{{ doc.uploadHint }}</p>
                                        </div>
                                        <div v-else class="new-doc-edit-form">
                                            <input v-model="doc.document_name" type="text" class="new-doc-input"
                                                placeholder="Enter document name"
                                                @keyup.enter="finishEditingDocument(idx)" :ref="`docInput-${idx}`" />
                                            <input v-model="doc.uploadHint" type="text" class="new-doc-input"
                                                placeholder="Enter upload hint (optional)"
                                                @keyup.enter="finishEditingDocument(idx)" />
                                            <div class="new-doc-radio-group" @click.stop>
                                                <label class="radio-label"><input type="radio" :value="true"
                                                        v-model="doc.isRequired" /> Required</label>
                                                <label class="radio-label"><input type="radio" :value="false"
                                                        v-model="doc.isRequired" /> Optional</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="new-doc-actions">
                                        <button type="button" class="doc-action-btn edit"
                                            @click.stop="editDocument(idx)">
                                            <feather-icon icon="EditIcon" svgClasses="h-6 w-6" />
                                            <span>Edit</span>
                                        </button>
                                        <button type="button" class="doc-action-btn delete"
                                            @click.stop="deleteDocument(idx)">
                                            <feather-icon icon="TrashIcon" svgClasses="h-6 w-6" />
                                            <span>Delete</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button class="request-doc-btn-new-booking" @click="addNewDocument">
                            <feather-icon icon="PlusIcon" svgClasses="h-5 w-5" />
                            <span>Request New Document</span>
                        </button>
                    </div>

                </div>
                <div class="panel-footer-sticky">
                    <vs-button class="w-full" color="dark" size="large" @click="openSaraiSelectionModal">
                        Select Sarai And Rooms
                    </vs-button>
                </div>
            </div>
        </div>

        <!-- Minimized New Booking Panel -->
        <div v-if="showNewBookingModal && isNewBookingMinimized" class="minimized-panel">
            <div class="minimized-panel-content">
                <div class="minimized-header">
                    <div class="minimized-title">
                        <h4>New Sarai Booking</h4>
                    </div>
                    <div class="minimized-controls">
                        <feather-icon icon="Maximize2Icon" svgClasses="h-6 w-6 text-black cursor-pointer"
                            title="Expand panel" @click.stop="toggleNewBookingMinimize" />
                        <feather-icon icon="XIcon" svgClasses="h-6 w-6 text-black cursor-pointer"
                            @click.stop="closeNewBookingModal" />
                    </div>
                </div>
            </div>
        </div>

        <!-- Sarai & Room Selection Modal (Second Modal) -->
        <div v-if="showSaraiSelectionModal && !isSaraiSelectionMinimized" class="detail-panel-overlay"
            @click="closeSaraiSelectionModal">
            <div class="detail-panel" @click.stop>
                <div class="panel-header" :class="{ 'flex-col': bookingSummaryString }">
                    <div class="w-full flex justify-between items-center">
                        <div class="panel-title flex items-center">
                            <feather-icon icon="ArrowLeftIcon" svgClasses="h-6 w-6 text-black cursor-pointer mr-3"
                                @click="goBackToNewBooking" />
                            <h3>Select Sarai & Room</h3>
                        </div>
                        <div class="panel-controls">
                            <feather-icon icon="Maximize2Icon" svgClasses="h-6 w-6 text-black cursor-pointer"
                                title="Collapse panel" @click.stop="toggleSaraiSelectionMinimize" />
                            <feather-icon icon="XIcon" svgClasses="h-6 w-6 text-black cursor-pointer"
                                @click.stop="closeSaraiSelectionModal" />
                        </div>
                    </div>
                    <div v-if="bookingSummaryString" class="w-full mt-2 pl-9">
                        <p class="text-sm font-semibold text-gray-600">{{ bookingSummaryString }}</p>
                    </div>
                </div>
                <div class="panel-content scrollable-modal-body px-5">
                    <!-- Select Sarai -->
                    <div class="form-section">
                        <label class="form-label">Select Sarai</label>
                        <select-2 :key="'new-booking-sarai-select'" class="w-full" :name="'new-booking-sarai'"
                            placeholder="Select Sarai" :options="saraiOptions" :autocomplete="false" :multiple="false"
                            :value="newBooking.saraiId"
                            @input="(item) => { newBooking.saraiId = item && item.value; loadRooms() }" />
                    </div>

                    <!-- Room Cards & Options -->
                    <div v-if="availableRooms.length > 0" class="form-section">
                        <h4 class="section-title">Available Rooms</h4>
                        <div class="rooms-list-popup">
                            <div v-for="(room, index) in availableRooms" :key="index" class="mb-4">
                                <!-- Room Card Detail UI -->
                                <div class="room-card-v2" :class="{
                                    'selected': getSelectedRoom(room.id),
                                    'sold-out': room.roomsLeft <= 0
                                }">
                                    <div class="room-card-inner">
                                        <!-- Header: Title and Share -->
                                        <div class="flex justify-between items-start mb-1">
                                            <div class="flex items-center gap-3 flex-wrap">
                                                <h4 class="room-title-v2">{{ room.name }}</h4>
                                                <span v-if="getSelectedRoom(room.id)" class="room-selected-badge">Selected</span>
                                            </div>
                                            <div class="share-btn-circular" @click.stop="shareRoom(room)">
                                                <feather-icon icon="Share2Icon" svgClasses="h-5 w-5" />
                                            </div>
                                        </div>

                                        <!-- Availability Status -->
                                        <div class="mb-5">
                                            <p v-if="room.roomsLeft > 0" class="room-availability-red">
                                                {{ room.roomsLeft }} rooms left
                                            </p>
                                            <p v-else class="room-availability-gray">
                                                No rooms available
                                            </p>
                                        </div>

                                        <!-- Featured Image -->
                                        <div class="room-image-container-v2 mb-6">
                                            <img v-if="room.image" :src="room.image" :alt="room.name"
                                                class="room-image-v2" />
                                            <div v-else class="room-image-placeholder-v2">
                                                <feather-icon icon="ImageIcon" svgClasses="h-10 w-10 text-gray-300" />
                                            </div>
                                        </div>

                                        <!-- Pricing Section -->
                                        <div class="pricing-section-v2 mb-1">
                                            <span class="price-main-v2">Rs. {{ formatPrice(room.price) }}</span>
                                            <span class="price-period-v2">per night</span>
                                        </div>
                                        <div class="flex flex-col gap-1 mb-5">
                                            <div class="text-sm text-gray-600">
                                                Rs. {{ formatPrice(room.price) }} x {{ numberOfNights }} night{{
                                                    numberOfNights > 1 ? 's' : ''
                                                }} = <span class="font-bold text-gray-800">Rs. {{ formatPrice(room.price
                                                    *
                                                    numberOfNights) }}</span>
                                            </div>
                                            <div class="text-sm text-gray-600 flex items-center">
                                                <span>+ Rs. {{ formatPrice(getTotalTaxAmount(room.price)) }}
                                                    taxes</span>
                                                <span
                                                    class="ml-2 text-xs bg-gray-100 px-2 py-0.5 rounded border border-gray-200 text-gray-600 font-semibold">{{
                                                        getTaxPercentage(room.price)
                                                    }}% GST</span>
                                            </div>
                                        </div>

                                        <!-- Amenities section -->
                                        <div v-if="room.amenities && room.amenities.length > 0" class="mb-6">
                                            <p class="text-sm font-bold text-gray-500 mb-3 uppercase tracking-wider">
                                                Amenities</p>
                                            <div class="amenities-container-v2">
                                                <div v-for="(amenity, aIdx) in room.amenities" :key="aIdx"
                                                    class="amenity-tag-v2">
                                                    <span>{{ formatAmenityName(amenity) }}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Trust & Info Badges -->
                                        <div class="trust-badges-container-v2 mb-8">
                                            <div class="trust-badge-item">
                                                <feather-icon icon="CheckIcon" svgClasses="h-5 w-5 mr-3 stroke-3" />
                                                <span>Free cancellation</span>
                                            </div>
                                            <div class="trust-badge-item">
                                                <feather-icon icon="ShieldIcon"
                                                    svgClasses="h-5 w-5 mr-3 fill-current" />
                                                <span>Verified and added by gurudwara</span>
                                            </div>
                                        </div>

                                        <!-- Selection Controls -->
                                        <div class="selection-action-v2">
                                            <div v-if="getSelectedRoom(room.id)" class="quantity-selector-v2">
                                                <button class="qty-btn-v2" @click.stop="decrementRoomQuantity(room)">
                                                    <feather-icon icon="MinusIcon" svgClasses="h-5 w-5" />
                                                </button>
                                                <div class="qty-value-v2">
                                                    {{ getSelectedRoom(room.id).number_of_rooms }}
                                                </div>
                                                <button class="qty-btn-v2" @click.stop="incrementRoomQuantity(room)"
                                                    :disabled="getSelectedRoom(room.id).number_of_rooms >= room.roomsLeft"
                                                    :class="{ 'disabled': getSelectedRoom(room.id).number_of_rooms >= room.roomsLeft }">
                                                    <feather-icon icon="PlusIcon" svgClasses="h-5 w-5" />
                                                </button>
                                            </div>
                                            <button v-else class="select-room-btn-v2" :disabled="room.roomsLeft <= 0"
                                                @click="selectRoom(room)">
                                                {{ room.roomsLeft > 0 ? 'Select This Room' : 'Sold Out' }}
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <!-- Options displayed right below the selected room -->
                                <div v-if="getSelectedRoom(room.id) && room.options && room.options.length > 0"
                                    class="ml-2 mt-4">
                                    <h4 class="text-md font-bold mb-4">Select Room Option</h4>
                                    <div class="options-horizontal-scroll">
                                        <div v-for="(option, optIdx) in room.options" :key="optIdx"
                                            class="option-card-premium"
                                            :class="{ 'selected': getSelectedRoom(room.id).option_idx === optIdx }"
                                            @click="() => { getSelectedRoom(room.id).option_idx = optIdx; getSelectedRoom(room.id).option_id = option._id; }">

                                            <div class="option-card-header">
                                                <div class="radio-indicator-premium"
                                                    :class="{ 'active': getSelectedRoom(room.id).option_idx === optIdx }">
                                                </div>
                                                <div class="option-title-group">
                                                    <span class="option-label">Option {{ optIdx + 1 }}</span>
                                                    <h4 class="option-main-title">{{ option.name }}</h4>
                                                </div>
                                            </div>

                                            <div class="option-features">
                                                <div class="feature-item">{{ option.description }}</div>
                                                <div class="feature-item">capacity: {{ option.capacity }}</div>
                                            </div>

                                            <div class="option-price-section">
                                                <div class="option-price">Rs. {{ formatPrice(option.price) }}</div>
                                                <div class="flex flex-col gap-1 mt-2">
                                                    <div class="text-sm text-gray-600">
                                                        Rs. {{ formatPrice(option.price) }} x {{ numberOfNights }}
                                                        night{{
                                                            numberOfNights > 1 ? 's' :
                                                                ''
                                                        }} = <span class="font-bold text-gray-800">Rs. {{
                                                            formatPrice(option.price * numberOfNights) }}</span>
                                                    </div>
                                                    <div class="text-sm text-gray-600 flex items-center">
                                                        <span>+ Rs. {{ formatPrice(getTotalTaxAmount(option.price)) }}
                                                            taxes</span>
                                                        <span
                                                            class="ml-2 text-xs bg-gray-100 px-2 py-0.5 rounded border border-gray-200 text-gray-600 font-semibold">{{
                                                                getTaxPercentage(option.price) }}% GST</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <vs-button class="w-full mt-5"
                                                :color="getSelectedRoom(room.id).option_idx === optIdx ? 'dark' : '#f3f4f6'"
                                                :text-color="getSelectedRoom(room.id).option_idx === optIdx ? 'white' : 'black'"
                                                @click.stop="() => { getSelectedRoom(room.id).option_idx = optIdx; getSelectedRoom(room.id).option_id = option._id; }">
                                                {{ getSelectedRoom(room.id).option_idx === optIdx ? 'Selected' : 'Select This Option' }}
                                            </vs-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="panel-footer-sticky">
                    <vs-button
                        v-if="featureFlags.enablePaymentGateway"
                        class="w-full"
                        color="dark"
                        size="large"
                        text-color="white"
                        @click="sendPaymentRequestLink"
                        :disabled="!isSelectionComplete"
                    >
                        Send Payment Request {{ formattedBookingAmountSuffix }}
                    </vs-button>
                    <vs-button
                        v-else
                        class="w-full"
                        color="dark"
                        size="large"
                        text-color="white"
                        @click="confirmBooking"
                        :disabled="!isSelectionComplete"
                    >
                        Confirm Booking {{ formattedBookingAmountSuffix }}
                    </vs-button>
                </div>
            </div>
        </div>

        <!-- Minimized Sarai Selection Panel -->
        <div v-if="showSaraiSelectionModal && isSaraiSelectionMinimized" class="minimized-panel">
            <div class="minimized-panel-content">
                <div class="minimized-header">
                    <div class="minimized-title">
                        <h4>Select Sarai & Room</h4>
                    </div>
                    <div class="minimized-controls">
                        <feather-icon icon="Maximize2Icon" svgClasses="h-6 w-6 text-black cursor-pointer"
                            title="Expand panel" @click.stop="toggleSaraiSelectionMinimize" />
                        <feather-icon icon="XIcon" svgClasses="h-6 w-6 text-black cursor-pointer"
                            @click.stop="closeSaraiSelectionModal" />
                    </div>
                </div>
            </div>
        </div>

        <!-- Detailed Booking Panel (View Details) -->
        <div v-if="showDetailPanel && !isPanelMinimized" ref="detailOverlay" class="detail-panel-overlay" @click="closeDetailPanel">
            <div class="detail-panel" @click.stop>
                <!-- Panel Header -->
                <div class="panel-header flex-col items-start p-6 border-b sticky top-0 z-10"
                    style="border-radius: 24px 24px 0 0;">
                    <div class="flex items-center justify-between w-full">
                        <div class="panel-title">
                            <h3 class="text-3xl font-extrabold">{{ selectedBooking ? selectedBooking.userName : ""
                                }}</h3>
                        </div>
                        <div class="panel-controls flex items-center gap-6">
                            <div class="control-icon" @click.stop="refreshBookingDetails" title="Refresh Details">
                                <feather-icon icon="RotateCwIcon" svgClasses="h-6 w-6 text-black" />
                            </div>
                            <div class="control-icon" @click.stop="togglePanelMinimize" title="Collapse panel">
                                <feather-icon icon="Maximize2Icon" svgClasses="h-6 w-6 text-black" />
                            </div>
                            <div class="control-icon" @click.stop="closeDetailPanel" title="Close Panel">
                                <feather-icon icon="XIcon" svgClasses="h-6 w-6 text-black" />
                            </div>
                        </div>
                    </div>
                    <div class="booking-summary mt-4 flex flex-col gap-3">
                        <div class="flex flex-wrap gap-2">
                            <span class="font-bold cursor-default"
                                style="font-size: 17px; padding:6px 14px; background-color: #FBE375; color:#2C0146; border-radius: 8px;">Sarai
                                Booking</span>

                            <span class="bg-black text-white font-bold cursor-default"
                                style="font-size: 17px; padding:6px 14px; border-radius: 8px;">
                                {{ selectedBooking ? selectedBooking.dateRange : "" }} · {{ selectedBooking ?
                                    selectedBooking.amount : "" }}
                            </span>
                        </div>
                        <div class="flex flex-wrap gap-2">
                            <span
                                v-if="selectedBookingDisplayStatus === 'rejected'"
                                class="tag danger font-bold">Rejected</span>
                            <span
                                v-else-if="selectedBookingDisplayStatus === 'cancelled'"
                                class="tag danger font-bold">Cancelled</span>
                            <span
                                v-else-if="selectedBookingDisplayStatus === 'refunded'"
                                class="tag warning font-bold">Refunded</span>
                            <span
                                v-else-if="selectedBookingDisplayStatus === 'pending'"
                                class="tag warning font-bold">Pending</span>
                            <span
                                v-else-if="selectedBookingDisplayStatus === 'confirmed'"
                                class="tag success font-bold">Confirmed</span>

                            <span
                                v-if="selectedBooking && selectedBooking.rawData && selectedBooking.rawData.requested_documents && selectedBooking.rawData.requested_documents.length > 0"
                                class="tag flex items-center gap-2 font-bold"
                                :class="{ success: hasDocsApproved(selectedBooking), warning: !hasDocsApproved(selectedBooking) }">
                                <feather-icon v-if="hasDocsApproved(selectedBooking)" icon="CheckIcon"
                                    svgClasses="h-5 w-5 text-black" />

                                {{ hasDocsApproved(selectedBooking) ? 'Documents Approved' : 'Documents Unapproved' }}
                            </span>
                            <span
                                v-if="selectedBookingDisplayStatus === 'pending'"
                                class="tag warning font-bold">Pending Payment</span>
                        </div>
                    </div>
                </div>

                <div class="panel-content scrollable-modal-body py-6">
                    <!-- Customer Details Section -->
                    <vs-collapse accordion class="p-0">
                        <vs-collapse-item open class="p-0">
                            <div slot="header" class="text-lg font-bold p-0">Customer Details</div>
                            <div class="contact-info py-2">
                                <div class="vx-row mb-4">
                                    <div class="vx-col w-1/2">
                                        <div class="text-gray-500 font-bold text-base mb-1">Customer Name</div>
                                        <div class="text-lg text-black capitalize">{{
                                            selectedBooking ? selectedBooking.userName : '-' }}</div>
                                    </div>
                                    <div class="vx-col w-1/2">
                                        <div class="text-gray-500 font-bold text-base mb-1">Sangat Handle Name</div>
                                        <div class="flex items-center gap-2">
                                            <span class="text-base  text-black">{{ selectedBooking ?
                                                selectedBooking.sangatId || '-' : '-' }}</span>
                                            <feather-icon icon="CopyIcon" svgClasses="h-4 w-4 cursor-pointer text-black"
                                                @click="copyToClipboard(selectedBooking.sangatId)" />
                                        </div>
                                    </div>
                                </div>

                                <div class="vx-row mb-4">
                                    <div class="vx-col w-1/2">
                                        <div class="text-gray-500 font-bold text-base mb-1">Email</div>
                                        <div class="flex items-center gap-2">
                                            <span class="text-base  text-black truncate"
                                                :title="selectedBooking ? selectedBooking.email : ''">{{ selectedBooking
                                                    ? selectedBooking.email || '-' : '-' }}</span>
                                            <feather-icon icon="CopyIcon" svgClasses="h-4 w-4 cursor-pointer text-black"
                                                @click="copyToClipboard(selectedBooking.email)" />
                                        </div>
                                    </div>
                                    <div v-if="selectedBooking && selectedBooking.phone && selectedBooking.phone !== '-'"
                                        class="vx-col w-1/2">
                                        <div class="text-gray-500 font-bold text-base mb-1">Phone</div>
                                        <div class="flex items-center gap-2">
                                            <span class="text-base  text-black">{{ selectedBooking ?
                                                selectedBooking.phone || '-' : '-' }}</span>
                                            <feather-icon icon="CopyIcon" svgClasses="h-4 w-4 cursor-pointer text-black"
                                                @click="copyToClipboard(selectedBooking.phone)" />
                                            <feather-icon icon="MessageCircleIcon"
                                                svgClasses="h-4 w-4 cursor-pointer text-black"
                                                @click="openWhatsApp(selectedBooking.phone)" />
                                        </div>
                                    </div>
                                </div>

                                <div class="vx-row mb-4">
                                    <div class="vx-col w-1/2">
                                        <div class="text-gray-500 font-bold text-base mb-1">Phone Number</div>
                                        <div class="flex items-center gap-2">
                                            <span class="text-lg text-black">{{ selectedBooking ?
                                                selectedBooking.userPhone : '-' }}</span>
                                            <feather-icon icon="CopyIcon"
                                                svgClasses="h-5 w-5 cursor-pointer text-gray-500"
                                                @click="copyToClipboard(selectedBooking.userPhone)" />
                                            <feather-icon icon="MessageCircleIcon"
                                                svgClasses="h-5 w-5 cursor-pointer text-green-500"
                                                @click="openWhatsApp(selectedBooking.userPhone)" />
                                        </div>
                                    </div>
                                    <div class="vx-col w-1/2">
                                        <div class="text-gray-500 font-bold text-base mb-1">Booking ID</div>
                                        <div class="flex items-center gap-4">
                                            <span class="text-base  text-black">{{ selectedBooking ?
                                                selectedBooking.bookingId : '-' }}</span>
                                            <div class="cursor-pointer border border-gray-300 rounded-full px-4 py-1 flex items-center gap-2 hover:bg-gray-50 transition-colors"
                                                @click="copyToClipboard(selectedBooking.bookingId)">
                                                <feather-icon icon="CopyIcon" svgClasses="h-4 w-4 text-black" />
                                                <span class="text-sm font-bold text-black">Copy</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="vx-row mb-4">
                                    <div class="vx-col w-full">
                                        <div class="text-gray-500 font-bold text-base mb-1">Booking Date & Time</div>
                                        <div class="text-base  text-black">{{ selectedBooking ?
                                            selectedBooking.bookingDate : '-' }}</div>
                                    </div>
                                </div>
                                <div v-if="selectedBooking && selectedBooking.alternatePhone && selectedBooking.alternatePhone !== '-'"
                                    class="vx-row mb-4">
                                    <div class="vx-col w-full">
                                        <div class="text-gray-500 font-bold text-base mb-1">Alternate Phone Number</div>
                                        <div class="flex items-center gap-2">
                                            <span class="text-base  text-black">{{ selectedBooking ?
                                                selectedBooking.alternatePhone || '-' : '-' }}</span>
                                            <feather-icon icon="CopyIcon" svgClasses="h-4 w-4 cursor-pointer text-black"
                                                @click="copyToClipboard(selectedBooking.alternatePhone)" />
                                            <feather-icon icon="MessageCircleIcon"
                                                svgClasses="h-4 w-4 cursor-pointer text-black"
                                                @click="openWhatsApp(selectedBooking.alternatePhone)" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </vs-collapse-item>

                        <!-- Booking Venue & Rooms Section -->
                        <vs-collapse-item>
                            <div slot="header" class="text-lg font-bold">Booking Venue & Rooms</div>
                            <div class="py-2">
                                <div class="flex mb-4 items-center" style="gap: 15px;">
                                    <span class="bg-black text-white rounded cursor-default"
                                        style="font-size: 17px; padding:5px 10px;">
                                        {{ selectedBooking ? selectedBooking.dateRange : "" }} · {{ selectedBooking ?
                                            selectedBooking.amount : "" }}
                                    </span>
                                    <span class="font-bold text-gray-700" style="font-size: 16px;">
                                        {{ selectedBookingSummaryString }}
                                    </span>
                                </div>
                                <div class="flex items-center p-3 border rounded-lg bg-gray-50 mb-4">
                                    <img v-if="selectedBooking && selectedBooking.image" :src="selectedBooking.image"
                                        class="w-16 h-16 rounded object-cover mr-4">
                                    <div v-else
                                        class="w-16 h-16 rounded bg-gray-200 mr-4 flex items-center justify-center">
                                        <feather-icon icon="ImageIcon" svgClasses="h-8 w-8 text-gray-400" />
                                    </div>
                                    <div>
                                        <h4 class="font-bold text-lg">{{ selectedBooking ? selectedBooking.saraiName :
                                            '-' }}</h4>
                                        <p class="text-gray-500 text-sm">{{ selectedBooking ? selectedBooking.location :
                                            '-' }}</p>
                                    </div>
                                </div>
                                <div class="border rounded-lg overflow-hidden border-black border-solid">
                                    <div class="bg-gray-50 p-3 font-bold border-b">Rooms Booked</div>
                                    <div class="p-4">
                                        <div
                                            v-if="selectedBooking && selectedBooking.rawData && selectedBooking.rawData.rooms && selectedBooking.rawData.rooms.length > 0">
                                            <div v-for="(room, index) in selectedBooking.rawData.rooms" :key="index"
                                                class="mb-3 last:mb-0 border-b border-gray-100 last:border-0 pb-3 last:pb-0">
                                                <div class="flex items-start justify-between">
                                                    <div>
                                                        <ul class="list-disc">
                                                            <li class="font-bold text-gray-800">{{ room.room_type ||
                                                                room.type ||
                                                                room.name || 'Room' }}
                                                            </li>
                                                        </ul>
                                                        <div class=" mt-1">
                                                            <div v-if="room.option || room.name"
                                                                class="text-sm text-gray-600 font-medium">
                                                                {{ (room.option ? room.option.name : null) || room.name
                                                                }}
                                                            </div>
                                                            <div v-if="room.room_name"
                                                                class="text-sm text-gray-500 mt-1">
                                                                Room No: {{ room.room_name }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="text-right">
                                                        <div class="font-bold text-gray-800">{{ room.number_of_rooms }}
                                                            Room{{ room.number_of_rooms > 1 ? 's' : '' }}</div>
                                                        <div class="text-xs text-gray-500 mt-1">₹{{ room.price_per_night
                                                        }} / night</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else class="flex items-center justify-between mb-2">
                                            <ul class="list-disc pl-5">
                                                <li>{{ selectedBooking && selectedBooking.rawData &&
                                                    selectedBooking.rawData.room ?
                                                    (selectedBooking.rawData.room.room_type ||
                                                        selectedBooking.rawData.room.type ||
                                                        selectedBooking.rawData.room.name || '-') : '-' }}</li>
                                            </ul>
                                            <span class="font-semibold">{{ selectedBooking && selectedBooking.rawData ?
                                                selectedBooking.rawData.number_of_rooms : '1' }} Room</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </vs-collapse-item>

                        <!-- Price Breakup Section -->
                        <vs-collapse-item>
                            <div slot="header" class="text-lg font-bold">Price Breakup</div>
                            <div class="py-2">
                                <div class="border rounded-lg p-4 bg-white">
                                    <div class="flex justify-between mb-4">
                                        <span class="text-lg">Subtotal</span>
                                        <span class="font-bold">₹{{ selectedBooking && selectedBooking.rawData ?
                                            (selectedBooking.rawData.subtotal ||
                                                selectedBooking.rawData.room_charge_per_night || '0') :
                                            '0' }}</span>

                                    </div>
                                    <div class="flex justify-between mb-4">
                                        <span class="text-lg">Taxes</span>
                                        <span class="font-bold">₹{{ selectedBooking && selectedBooking.rawData ?
                                            (selectedBooking.rawData.taxes || selectedBooking.rawData.total_tax || '0')
                                            : '0' }}</span>
                                    </div>
                                    <vs-divider class="my-3"></vs-divider>
                                    <div class="flex justify-between items-center bg-gray-50 -mx-4 -mb-4 p-4">
                                        <span class="text-lg font-bold">Total Amount</span>
                                        <span class="text-lg font-bold">₹{{ selectedBooking && selectedBooking.rawData ?
                                            selectedBooking.rawData.total_amount : '0' }}</span>
                                    </div>
                                </div>
                            </div>
                        </vs-collapse-item>

                        <vs-collapse-item v-if="hasCancellationRefundDetails" open class="p-0 mt-4">
                            <div slot="header" class="text-lg font-bold p-0">Cancellation & Refund</div>
                            <div class="py-2">
                                <div class="border rounded-lg p-4 bg-white space-y-3">
                                    <div class="flex justify-between text-base">
                                        <span class="text-gray-500 font-bold">Booking Total</span>
                                        <span class="font-bold">₹{{ selectedBooking.rawData.cancellation_details.total_amount || selectedBooking.rawData.total_amount || 0 }}</span>
                                    </div>
                                    <div class="flex justify-between text-base">
                                        <span class="text-gray-500 font-bold">Cancellation Charge</span>
                                        <span class="font-bold text-red-600">- ₹{{ selectedBooking.rawData.cancellation_details.cancellation_charge || 0 }}</span>
                                    </div>
                                    <div class="flex justify-between text-base border-t pt-3">
                                        <span class="text-gray-500 font-bold">Refund Amount</span>
                                        <span class="font-bold text-green-700">₹{{ selectedBooking.rawData.cancellation_details.refund_amount || 0 }}</span>
                                    </div>
                                    <p v-if="selectedBooking.rawData.cancellation_details.charge_percentage !== undefined" class="text-sm text-gray-500 mb-0">
                                        Charge applied: {{ selectedBooking.rawData.cancellation_details.charge_percentage }}%
                                    </p>
                                    <p v-if="selectedBooking.rawData.cancellation_details.cancellation_reason" class="text-sm text-gray-600 mb-0">
                                        Reason: {{ selectedBooking.rawData.cancellation_details.cancellation_reason }}
                                    </p>
                                </div>
                            </div>
                        </vs-collapse-item>

                        <!-- Documents Section -->
                        <vs-collapse-item>
                            <div slot="header" class="text-lg font-bold">Documents</div>
                            <div class="py-2">
                                <div class="documents-grid-detail">
                                    <!-- Existing Documents -->
                                    <div class="documents-section">
                                        <div class="documents-grid text-left">

                                            <!-- Existing Documents -->
                                            <div v-for="doc in documents" :key="doc.key" class="document-card"
                                                :class="[`status-${doc.status}`]">
                                                <h5 class="document-title">{{ doc.document_name }}</h5>
                                                <div class="flex gap-5 mt-5">

                                                    <!-- Document Image/Preview -->
                                                    <div class="document-media"
                                                        @click="hasDocFiles(doc) && openDocPreview(doc.file_urls)">
                                                        <img v-if="hasDocFiles(doc)" :src="primaryDocImage(doc)"
                                                            class="document-image" alt="document" />

                                                        <div v-else class="document-placeholder">
                                                            <div class="document-icon">📄</div>
                                                            <div class="document-text">{{ doc.document_name }}</div>
                                                        </div>

                                                        <div v-if="hasDocFiles(doc)" class="doc-overlay-icons">
                                                            <span v-if="getDocFileCount(doc) > 1"
                                                                class="doc-multi-count">
                                                                {{ getDocFileCount(doc) }}
                                                            </span>

                                                            <feather-icon icon="Maximize2Icon"
                                                                svgClasses="h-6 w-6 cursor-pointer"
                                                                @click.stop="openDocPreview(doc.file_urls)" />
                                                        </div>

                                                        <input :ref="`docInput-${doc.key}`" type="file" accept="image/*"
                                                            multiple class="hidden"
                                                            @change="onDocFileChange(doc.key, $event)" />
                                                    </div>

                                                    <!-- Pending -->
                                                    <div v-if="doc.status === 'pending'"
                                                        class="document-actions-pending">
                                                        <button type="button" class="doc-btn accept"
                                                            :disabled="!hasDocFiles(doc)"
                                                            @click="setDocumentStatus(doc.key, 'accepted')">
                                                            Accept
                                                        </button>
                                                        <button type="button" class="doc-btn reject"
                                                            @click="setDocumentStatus(doc.key, 'rejected')">
                                                            Reject
                                                        </button>
                                                    </div>

                                                    <!-- Accepted -->
                                                    <div v-else-if="doc.status === 'accepted'"
                                                        class="document-status-accepted"
                                                        :class="{ 'disabled-state': isBookingClosed }">
                                                        <div class="status-accepted-box">
                                                            <feather-icon icon="CheckIcon"
                                                                svgClasses="h-6 w-6 text-black" />
                                                            <span>Accepted</span>
                                                        </div>
                                                        <button type="button" class="doc-btn undo"
                                                            @click="setDocumentStatus(doc.key, 'pending')"
                                                            :disabled="isBookingClosed">
                                                            <feather-icon icon="RotateCcwIcon"
                                                                svgClasses="h-6 w-6 text-black" />
                                                            Undo
                                                        </button>
                                                    </div>

                                                    <!-- Rejected -->
                                                    <div v-else-if="doc.status === 'rejected'"
                                                        class="document-status-rejected"
                                                        :class="{ 'disabled-state': isBookingClosed }">
                                                        <div class="status-rejected-box">
                                                            <feather-icon icon="XIcon" svgClasses="h-6 w-6" />
                                                            <div class="rejected-content">
                                                                <span class="rejected-title">Rejected</span>
                                                                <span class="rejected-message">
                                                                    {{ doc.rejectionReason || 'Incorrect document uploaded.' }}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <button type="button" class="doc-btn undo"
                                                            @click="setDocumentStatus(doc.key, 'pending')"
                                                            :disabled="isBookingClosed">
                                                            <feather-icon icon="RotateCcwIcon" svgClasses="h-6 w-6" />
                                                            Undo
                                                        </button>
                                                    </div>

                                                </div>
                                            </div>

                                            <!-- Requested Documents (Saved) -->
                                            <div v-for="(reqDoc, idx) in requestedDocuments"
                                                :key="`requested-doc-${idx}`" class="document-card new-document-card"
                                                @click="handleRequestedDocCardClick(idx, $event)">
                                                <div class="new-document-content">
                                                    <div class="new-doc-left">
                                                        <div v-if="!reqDoc.isEditing" class="new-doc-info">
                                                            <h5 class="document-title">{{ reqDoc.document_name || 'New Document' }}</h5>
                                                            <p class="new-doc-requirement">{{ reqDoc.isRequired ? 'Required' : 'Optional' }}</p>
                                                            <p v-if="reqDoc.uploadHint" class="new-doc-hint">{{reqDoc.uploadHint }}</p>
                                                        </div>

                                                        <div v-else class="new-doc-edit-form">
                                                            <input v-model="reqDoc.document_name" type="text"
                                                                class="new-doc-input"
                                                                @keyup.enter="finishEditingRequestedDocument(idx)" />
                                                            <input v-model="reqDoc.uploadHint" type="text"
                                                                class="new-doc-input"
                                                                @keyup.enter="finishEditingRequestedDocument(idx)"
                                                                @click.stop />
                                                            <div class="new-doc-radio-group" @click.stop>
                                                                <label class="radio-label" @click.stop>
                                                                    <input type="radio" :value="true"
                                                                        v-model="reqDoc.isRequired" class="radio-input"
                                                                        @click.stop />
                                                                    <span>Required</span>
                                                                </label>
                                                                <label class="radio-label" @click.stop>
                                                                    <input type="radio" :value="false"
                                                                        v-model="reqDoc.isRequired" class="radio-input"
                                                                        @click.stop />
                                                                    <span>Optional</span>
                                                                </label>
                                                            </div>
                                                        </div>

                                                    </div>

                                                    <div class="new-doc-actions">
                                                        <button type="button" class="doc-action-btn edit"
                                                            @click.stop="editRequestedDocument(idx)">
                                                            <feather-icon icon="EditIcon" svgClasses="h-6 w-6" />
                                                            <span>Edit</span>
                                                        </button>
                                                        <button type="button" class="doc-action-btn delete"
                                                            @click.stop="deleteRequestedDocument(idx)">
                                                            <feather-icon icon="TrashIcon" svgClasses="h-6 w-6" />
                                                            <span>Delete</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- New Documents (Temp) -->
                                            <div v-for="(newDoc, idx) in newDocuments" :key="`new-doc-${idx}`"
                                                class="document-card new-document-card"
                                                @click="handleNewDocCardClick(idx, $event)">
                                                <div class="new-document-content">
                                                    <div class="new-doc-left">
                                                        <div v-if="!newDoc.isEditing" class="new-doc-info">
                                                            <h5 class="document-title">{{ newDoc.document_name || 'New Document' }}</h5>
                                                            <p class="new-doc-requirement">{{ newDoc.isRequired ? 'Required' : 'Optional' }}</p>
                                                            <p v-if="newDoc.uploadHint" class="new-doc-hint">{{
                                                                newDoc.uploadHint }}</p>
                                                        </div>

                                                        <div v-else class="new-doc-edit-form">
                                                            <input v-model="newDoc.document_name" type="text"
                                                                class="new-doc-input"
                                                                @keyup.enter="finishEditingNewDocument(idx)" />
                                                            <input v-model="newDoc.uploadHint" type="text"
                                                                class="new-doc-input"
                                                                @keyup.enter="finishEditingNewDocument(idx)"
                                                                @click.stop />
                                                            <div class="new-doc-radio-group" @click.stop>
                                                                <label class="radio-label" @click.stop>
                                                                    <input type="radio" :value="true"
                                                                        v-model="newDoc.isRequired" class="radio-input"
                                                                        @click.stop />
                                                                    <span>Required</span>
                                                                </label>
                                                                <label class="radio-label" @click.stop>
                                                                    <input type="radio" :value="false"
                                                                        v-model="newDoc.isRequired" class="radio-input"
                                                                        @click.stop />
                                                                    <span>Optional</span>
                                                                </label>
                                                            </div>
                                                        </div>

                                                    </div>

                                                    <div class="new-doc-actions">
                                                        <button type="button" class="doc-action-btn edit"
                                                            @click.stop="editNewDocument(idx)">
                                                            <feather-icon icon="EditIcon" svgClasses="h-6 w-6" />
                                                            <span>Edit</span>
                                                        </button>
                                                        <button type="button" class="doc-action-btn delete"
                                                            @click.stop="deleteNewDocument(idx)">
                                                            <feather-icon icon="TrashIcon" svgClasses="h-6 w-6" />
                                                            <span>Delete</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <button type="button" class="request-doc-btn-new-booking mt-5"
                                            @click="addRequestedDocument">
                                            <feather-icon icon="PlusIcon" svgClasses="h-5 w-5" />
                                            <span>Request New Document</span>
                                        </button>

                                        <div v-if="documentsModified" class="save-changes-container-docs">
                                            <vs-button type="filled" class="save-changes-btn" color="success"
                                                @click="saveBookingChanges">Save Changes</vs-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </vs-collapse-item>
                    </vs-collapse>
                </div>

                <!-- Panel Footer Sticky -->
                <div class="action-buttons p-6">
                    <div v-if="canManageBookingStatus" class="status-action-container"
                        ref="statusActionRef">
                        <vs-button type="border" class="action-btn"
                            @click.stop="toggleStatusMenu">
                            <div class="flex items-center gap-2">
                                <span>

                                    <feather-icon icon="ChevronUpIcon" svgClasses="h-6 w-6 " />
                                </span>
                                <span class="whitespace-no-wrap">
                                    Mark As

                                </span>
                            </div>
                        </vs-button>
                        <div v-if="showStatusMenu" class="status-menu" @click.stop>
                            <button v-for="opt in statusMenuOptionsForBooking" :key="opt.value" type="button"
                                class="status-menu-item" @click="applyStatusChange(opt.value)">
                                {{ opt.label }}
                            </button>
                        </div>
                    </div>
                    <vs-button type="relief" class="action-btn" style="width:343px;"
                        v-if="featureFlags.enablePaymentGateway && selectedBooking && !isClosedBooking && selectedBookingDisplayStatus !== 'confirmed'"
                        :disabled="!hasDocsApproved(selectedBooking)" @click="openPaymentRequestPanel()">
                        <div class="flex items-center gap-2">
                            <span>
                                Set Fees For Payment Request
                            </span>
                            <span class="mt-2">
                                <feather-icon icon="ChevronRightIcon" svgClasses="h-6 w-6" />
                            </span>
                        </div>
                    </vs-button>
                    <p v-if="!featureFlags.enablePaymentGateway && selectedBooking" class="text-base text-center mt-4 p-4 rounded-lg" style="background:#f0fdf4;border:1px solid #86efac;color:#166534;">
                        Reservation only — guest pays at sarai on arrival.
                    </p>
                </div>
            </div>
        </div>

        <!-- Document Preview Modal -->
        <vs-popup class="doc-preview-modal" title="Document Preview" :active.sync="showDocPreviewModal">
            <div v-if="previewImageUrls.length > 0" class="p-4" style="max-height: 80vh; overflow-y: auto;">
                <img v-for="(url, idx) in previewImageUrls" :key="idx" :src="url"
                    class="w-full mb-4 rounded-lg border border-gray-200" />
            </div>
            <div v-else class="p-4 text-center text-gray-500">
                No preview available
            </div>
        </vs-popup>

        <!-- Reason Modal -->
        <div v-if="showReasonModal" class="reason-modal-overlay" @click="closeReasonModal">
            <div class="reason-modal" @click.stop>
                <div class="reason-modal-header">
                    <h3 class="reason-modal-title">{{ reasonModalTitle }}</h3>
                    <button class="reason-modal-close" @click="closeReasonModal">
                        <feather-icon icon="XIcon" svgClasses="h-6 w-6" />
                    </button>
                </div>
                <div class="reason-modal-body">
                    <p class="reason-modal-description">{{ reasonModalDescription }}</p>

                    <div v-if="pendingStatusAction === 'Cancelled' && selectedPaymentReceived" class="cancellation-refund-panel">
                        <div class="refund-summary-card">
                            <div class="refund-row">
                                <span>Booking Total</span>
                                <strong>₹{{ formatPrice(bookingTotalAmount) }}</strong>
                            </div>
                            <div v-if="daysUntilCheckIn !== null" class="refund-hint">
                                Check-in in {{ daysUntilCheckIn }} day{{ daysUntilCheckIn === 1 ? '' : 's' }}.
                                Suggested charge: {{ cancellationChargePercentage }}%
                            </div>
                        </div>

                        <div class="refund-presets">
                            <button type="button" class="refund-preset-btn" :class="{ active: cancellationChargePercentage === 0 }" @click="applyCancellationPreset(0)">Full Refund (0%)</button>
                            <button type="button" class="refund-preset-btn" :class="{ active: cancellationChargePercentage === 10 }" @click="applyCancellationPreset(10)">10% Charge</button>
                            <button type="button" class="refund-preset-btn" :class="{ active: cancellationChargePercentage === 25 }" @click="applyCancellationPreset(25)">25% Charge</button>
                            <button type="button" class="refund-preset-btn" :class="{ active: cancellationChargePercentage === 50 }" @click="applyCancellationPreset(50)">50% Charge</button>
                            <button type="button" class="refund-preset-btn" :class="{ active: cancellationChargePercentage === 100 }" @click="applyCancellationPreset(100)">No Refund (100%)</button>
                        </div>

                        <label class="refund-field-label">Cancellation Charge (₹)</label>
                        <input
                            v-model.number="cancellationCharge"
                            type="number"
                            min="0"
                            :max="bookingTotalAmount"
                            class="refund-input"
                            @input="updateRefundFromCharge"
                        />

                        <div class="refund-row refund-row-highlight">
                            <span>Refund Amount</span>
                            <strong class="refund-amount">₹{{ formatPrice(refundAmount) }}</strong>
                        </div>
                    </div>

                    <textarea v-model="rejectionReason" class="reason-textarea"
                        :placeholder="pendingStatusAction === 'Cancelled' ? 'Enter reason for cancellation...' : 'Enter reason for rejection...'" rows="5"></textarea>
                </div>
                <div class="reason-modal-footer">
                    <button class="reason-btn-cancel" @click="closeReasonModal">
                        Cancel
                    </button>
                    <button class="reason-btn-confirm" @click="confirmReasonSubmit">
                        {{ reasonConfirmButtonText }}
                    </button>
                </div>
            </div>
        </div>

        <!-- Minimized Detail Panel -->
        <div v-if="showDetailPanel && isPanelMinimized" class="minimized-panel">
            <div class="minimized-panel-content">
                <div class="minimized-header">
                    <div class="minimized-title">
                        <h4>{{ selectedBooking ? selectedBooking.userName : "" }}</h4>
                    </div>
                    <div class="minimized-controls">
                        <feather-icon icon="Maximize2Icon" svgClasses="h-6 w-6 text-black cursor-pointer"
                            title="Expand panel" @click.stop="togglePanelMinimize" />
                        <feather-icon icon="XIcon" svgClasses="h-6 w-6 text-black cursor-pointer"
                            @click.stop="closeDetailPanel" />
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from '@/axios'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import Select2 from '@/components/custom/form-elements/Select2.vue'
import moment from 'moment'
import featureFlags from '@/config/featureFlags'
import { resolveGurudwaraIdFromContext } from '@/utils/portalGurudwara'

export default {
  name: 'SaraiBookings',
  components: {
    flatPickr,
    Select2
  },
  props: {
    overrideGurudwaraId: {
      type: String,
      default: null
    },
    dialogOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      featureFlags,
      activeTab: 0,
      filterSarai: null,
      filterUser: null,
      filterDate: null,
      filterResetKey: 0,
      clearingFilters: false,
      dateConfig: {
        dateFormat: 'Y-m-d',
        altInput: true,
        altFormat: 'd / m / Y',
        allowInput: false
      },
      saraiOptions: [],
      bookings: {
        pending: [],
        confirmed: [],
        rejected: [],
        cancelled: [],
        refunded: []
      },
      totalCounts: {
        pending: 0,
        confirmed: 0,
        rejected: 0,
        cancelled: 0,
        refunded: 0
      },
      loading: false,
      highlightedBookingIds: [],
      pendingHighlightId: null,
      highlightTimer: null,
      showNewBookingModal: false,
      showSaraiSelectionModal: false,
      isNewBookingMinimized: false,
      isSaraiSelectionMinimized: false,
      newBooking: {
        userId: null,
        dateRange: null,
        guests: { adults: 1, children: 0, infants: 0, pets: 0 },
        collectDocuments: false,
        documents: [
          {
            document_name: 'Passport',
            uploadHint: 'Upload both front and back side together.',
            isRequired: true,
            isEditing: false
          },
          {
            document_name: 'PAN Card',
            uploadHint: 'Upload both front and back side together.',
            isRequired: true,
            isEditing: false
          },
          {
            document_name: 'Aadhaar Card',
            uploadHint: 'Upload both front and back side together.',
            isRequired: true,
            isEditing: false
          }
        ],
        saraiId: null,
        selectedRooms: [] // Array of { room_id, number_of_rooms, option_id, option_idx }
      },
      dateRangeConfig: {
        mode: 'range',
        dateFormat: 'Y-m-d',
        altInput: true,
        altFormat: 'M d, Y',
        minDate: 'today'
      },
      availableRooms: [],
      roomOptions: [],
      showDetailPanel: false,
      isPanelMinimized: false,
      selectedBooking: null,
      documents: [],
      originalDocuments: [],
      requestedDocuments: [],
      originalRequestedDocuments: [],
      deletedRequestedDocIds: [],
      newDocuments: [],
      documentsModified: false,
      showStatusMenu: false,
      statusMenuOptions: [
        { label: 'Confirm Booking', value: 'Confirmed' },
        { label: 'Reject Booking', value: 'Rejected' },
        { label: 'Cancel Booking', value: 'Cancelled' },
        { label: 'Mark as Refunded', value: 'Refunded' }
      ],
      previewImageUrls: [],
      showDocPreviewModal: false,
      showReasonModal: false,
      rejectionReason: '',
      pendingStatusAction: null,
      reasonModalTitle: '',
      reasonModalDescription: '',
      reasonConfirmButtonText: 'Confirm Rejection',
      cancellationCharge: 0,
      refundAmount: 0,
      bookingTotalAmount: 0,
      cancellationChargePercentage: 0,
      daysUntilCheckIn: null,
      linkedBookingKey: null,
      resolvedGurudwaraId: null
    }
  },
  computed: {
    ...mapGetters('auth', ['checkPermissionSlug']),
    gurudwaraId() {
      return this.resolvedGurudwaraId
    },
    canShowNewBooking() {
      if (this.gurudwaraId) return true
      return this.checkPermissionSlug(['stay_edit', 'stay_view'])
    },
    currentStatus() {
      const statuses = ['pending', 'confirmed', 'rejected', 'cancelled', 'refunded']
      return statuses[this.activeTab] || 'pending'
    },
    userSearchParams() {
      return { role_slug: 'user', type: 'dropdown' }
    },
    isSelectionComplete() {
      if (this.newBooking.selectedRooms.length === 0) return false

      // For each selected room, if it has options, one must be selected
      for (const selRoom of this.newBooking.selectedRooms) {
        const room = this.availableRooms.find(r => r.id === selRoom.room_id)
        if (room && room.options && room.options.length > 0) {
          if (selRoom.option_idx === null || selRoom.option_idx === undefined) return false
        }
      }
      return true
    },
    hasActiveFilters() {
      return !!(this.filterSarai || this.filterUser || this.filterDate)
    },
    formattedBookingAmountSuffix() {
      const amount = Number(this.totalBookingAmount)
      return amount > 0 ? `(INR ${amount.toFixed(2)})` : ''
    },
    totalBookingAmount() {
      if (this.newBooking.selectedRooms.length === 0 || !this.newBooking.dateRange) return 0

      const nights = this.numberOfNights
      if (nights === 0) return 0

      let total = 0

      this.newBooking.selectedRooms.forEach(sr => {
        const room = this.availableRooms.find(r => r.id === sr.room_id)
        if (!room) return

        let unitPrice = 0
        if (sr.option_id && room.options) {
          const opt = room.options.find(o => o._id === sr.option_id)
          unitPrice = opt ? opt.price : room.price
        } else {
          unitPrice = room.price
        }

        const taxPerNight = parseFloat(this.getCalculatedTax(unitPrice)) || 0
        total += ((unitPrice * nights) + (taxPerNight * nights)) * sr.number_of_rooms
      })

      return parseFloat(total.toFixed(2))
    },
    numberOfNights() {
      if (!this.newBooking.dateRange) return 0
      const dates = this.newBooking.dateRange.split(' to ')
      if (dates.length !== 2) return 0
      const start = moment(dates[0])
      const end = moment(dates[1])
      return end.diff(start, 'days') || 1
    },
    bookingSummaryString() {
      // "3 Nights | 2 Adults, 1 Child, 0 Pets"
      const n = this.numberOfNights
      const g = this.newBooking.guests
      const parts = []
      if (n > 0) parts.push(`${n} Night${n > 1 ? 's' : ''}`)

      const guests = []
      if (g.adults > 0) guests.push(`${g.adults} Adult${g.adults > 1 ? 's' : ''}`)
      if (g.children > 0) guests.push(`${g.children} Child${g.children > 1 ? 'ren' : ''}`)
      if (g.pets > 0) guests.push(`${g.pets} Pet${g.pets > 1 ? 's' : ''}`)

      if (guests.length > 0) parts.push(guests.join(', '))

      return parts.join(' • ')
    },
    selectedBookingSummaryString() {
      if (!this.selectedBooking || !this.selectedBooking.rawData) return ''
      const b = this.selectedBooking.rawData
      const start = moment(b.check_in_date)
      const end = moment(b.check_out_date)
      const n = end.diff(start, 'days') || 1
      const g = b.guests || { adults: 0, children: 0, infants: 0, pets: 0 }

      const parts = []
      if (n > 0) parts.push(`${n} Night${n > 1 ? 's' : ''}`)

      const guests = []
      if (g.adults > 0) guests.push(`${g.adults} Adult${g.adults > 1 ? 's' : ''}`)
      if (g.children > 0) guests.push(`${g.children} Child${g.children > 1 ? 'ren' : ''}`)
      if (g.infants > 0) guests.push(`${g.infants} Infant${g.infants > 1 ? 's' : ''}`)
      if (g.pets > 0) guests.push(`${g.pets} Pet${g.pets > 1 ? 's' : ''}`)

      if (guests.length > 0) parts.push(guests.join(', '))

      return parts.join(' • ')
    },
    selectedBookingDisplayStatus() {
      return this.getBookingDisplayStatus(this.selectedBooking)
    },
    normalizedSelectedBookingStatus() {
      return this.selectedBookingDisplayStatus
    },
    isClosedBooking() {
      return ['rejected', 'cancelled', 'refunded', 'completed'].includes(this.selectedBookingDisplayStatus)
    },
    canManageBookingStatus() {
      if (this.isClosedBooking) return false
      return ['pending', 'confirmed'].includes(this.selectedBookingDisplayStatus)
    },
    statusMenuOptionsForBooking() {
      const status = this.selectedBookingDisplayStatus
      if (status === 'pending') {
        return [
          { label: 'Confirm Booking', value: 'Confirmed' },
          { label: 'Reject Booking', value: 'Rejected' },
          { label: 'Cancel Booking', value: 'Cancelled' }
        ]
      }
      if (status === 'confirmed') {
        const options = [
          { label: 'Cancel Booking', value: 'Cancelled' }
        ]
        if (this.selectedPaymentReceived) {
          options.push({ label: 'Mark as Refunded', value: 'Refunded' })
        }
        return options
      }
      return []
    },
    selectedPaymentReceived() {
      const booking = this.selectedBooking
      if (!booking) return false
      const raw = booking.rawData || {}
      const payment = String(booking.payment_status || raw.payment_status || '').toLowerCase()
      return payment === 'paid'
    },
    hasCancellationRefundDetails() {
      if (!this.selectedPaymentReceived && this.selectedBookingDisplayStatus !== 'refunded') return false
      const rawData = this.selectedBooking && this.selectedBooking.rawData
      const details = rawData && rawData.cancellation_details
      return Boolean(details && (details.cancellation_charge || details.refund_amount))
    }
  },
  watch: {
    activeTab() {
      this.loadBookings()
    },
    '$route.query.open'() {
      this.openLinkedBooking()
      if (this.$route.query && this.$route.query.focus === 'pending' && this.activeTab !== 0) {
        this.activeTab = 0
      }
    },
    filterSarai() {
      if (this.clearingFilters) return
      this.loadBookings()
    },
    filterDate() {
      if (this.clearingFilters) return
      this.loadBookings()
    },
    filterUser() {
      if (this.clearingFilters) return
      this.loadBookings()
    },
    'newBooking.dateRange'() {
      // When date range changes, update availability
      if (this.newBooking.saraiId) {
        this.updateAvailability()
      }
    }
  },
  async mounted() {
    await this.resolvePortalGurudwaraId()
    this.loadSaraiOptions()
    if (!this.dialogOnly) {
      this.loadBookings()
      this.openLinkedBooking()
    }
    if (this.dialogOnly || this.$route.query.newBooking === '1') {
      this.openNewBookingModal()
    }
  },
  beforeDestroy() {
    if (this.highlightTimer) {
      clearTimeout(this.highlightTimer)
      this.highlightTimer = null
    }
  },
  methods: {
    clearFilters() {
      if (!this.hasActiveFilters) return
      this.clearingFilters = true
      this.filterSarai = null
      this.filterUser = null
      this.filterDate = null
      this.filterResetKey += 1
      this.$nextTick(() => {
        this.clearingFilters = false
        this.loadBookings()
      })
    },
    getBookingDisplayStatus(booking) {
      if (!booking) return ''
      const raw = booking.rawData || booking
      const payment = String((booking.payment_status || (raw && raw.payment_status) || '')).toLowerCase()
      const status = String((booking.status || (raw && raw.status) || '')).toLowerCase()
      if (payment === 'refunded' || status === 'refunded') return 'refunded'
      return status
    },
    isHighlightedBooking(booking) {
      if (!booking || !booking._id) return false
      return this.highlightedBookingIds.indexOf(booking._id) !== -1
    },
    queueBookingHighlight(bookingId) {
      if (!bookingId) return
      this.pendingHighlightId = bookingId
    },
    applyNewBookingHighlights(list) {
      const bookings = Array.isArray(list) ? list : []
      const now = Date.now()
      const freshWindowMs = 2 * 60 * 1000
      const storageKey = 'sangat_sarai_seen_booking_ids'
      let seen = []
      try {
        seen = JSON.parse(sessionStorage.getItem(storageKey) || '[]')
      } catch (e) {
        seen = []
      }
      if (!Array.isArray(seen)) seen = []

      const idsToHighlight = []
      if (this.pendingHighlightId) {
        idsToHighlight.push(this.pendingHighlightId)
      }

      bookings.forEach((booking) => {
        if (!booking || !booking._id) return
        const created = booking.createdAt || (booking.rawData && (booking.rawData.createdAt || booking.rawData.created_at))
        const createdTime = created ? new Date(created).getTime() : 0
        const isFresh = createdTime && (now - createdTime) < freshWindowMs
        const notSeen = seen.indexOf(booking._id) === -1
        if (isFresh && notSeen) {
          idsToHighlight.push(booking._id)
        }
        if (notSeen) {
          seen.push(booking._id)
        }
      })

      if (seen.length > 200) {
        seen = seen.slice(seen.length - 200)
      }
      sessionStorage.setItem(storageKey, JSON.stringify(seen))
      this.pendingHighlightId = null

      const uniqueIds = []
      idsToHighlight.forEach((id) => {
        if (id && uniqueIds.indexOf(id) === -1) uniqueIds.push(id)
      })
      if (!uniqueIds.length) return

      this.highlightedBookingIds = this.highlightedBookingIds.concat(
        uniqueIds.filter((id) => this.highlightedBookingIds.indexOf(id) === -1)
      )
      if (this.highlightTimer) clearTimeout(this.highlightTimer)
      this.highlightTimer = setTimeout(() => {
        this.highlightedBookingIds = this.highlightedBookingIds.filter((id) => uniqueIds.indexOf(id) === -1)
        this.highlightTimer = null
      }, 6000)
    },
    formatDate(dateStr) {
      if (!dateStr) return '-'
      const date = new Date(dateStr)
      return date.toLocaleString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true }).replace(',', '')
    },
    formatDateRange(checkIn, checkOut) {
      if (!checkIn || !checkOut) return '-'
      const d1 = new Date(checkIn)
      const d2 = new Date(checkOut)
      const opts = { day: 'numeric', month: 'short' }
      const optsWithYear = { day: 'numeric', month: 'short', year: 'numeric' }
      return `${d1.toLocaleDateString('en-GB', opts)} - ${d2.toLocaleDateString('en-GB', optsWithYear)}`
    },
    normalizeFileList(list) {
      const queue = []
      if (Array.isArray(list)) {
        queue.push(...list)
      } else if (list) {
        queue.push(list)
      }

      const urls = []
      while (queue.length) {
        const item = queue.shift()
        if (!item) continue
        if (Array.isArray(item)) {
          queue.push(...item)
          continue
        }
        if (typeof item === 'string') {
          urls.push(item)
        } else if (typeof item === 'object') {
          const possible = item.url || item.file_url || item.document_url || item.path || item.source || item.src
          if (possible) urls.push(possible)
        }
      }
      return urls
    },
    getDocFileCount(doc) {
      if (!doc) return 0
      return this.normalizeFileList(doc.file_urls).length
    },
    hasDocFiles(doc) {
      return this.getDocFileCount(doc) > 0
    },
    primaryDocImage(doc) {
      if (!doc) return null
      const urls = this.normalizeFileList(doc.file_urls)
      return urls.length ? urls[0] : null
    },
    onDocFileChange(key, event) {
      const input = event && event.target
      const files = input && input.files ? Array.from(input.files) : []
      if (!files.length) return

      const readers = files.map(file => new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = (e) => resolve(e && e.target ? e.target.result : null)
        reader.onerror = () => reject(new Error('Failed to read file'))
        reader.readAsDataURL(file)
      }))

      Promise.all(readers).then((results) => {
        const fileUrls = results.filter(Boolean)
        if (!fileUrls.length) return
        // Update document locally
        this.documents = this.documents.map((d) => {
          if (d.key === key) {
            return { ...d, file_urls: fileUrls, status: 'pending' }
          }
          return d
        })
        this.documentsModified = true
        this.checkDocumentsModified()
        this.$vs.notify({ title: 'Upload', text: 'Document uploaded (preview only)', color: 'success', position: 'top-center', time: 2000 })
      }).catch(() => {
        this.$vs.notify({ title: 'Upload', text: 'Failed to process selected files', color: 'danger', position: 'top-center', time: 2000 })
      }).finally(() => {
        if (input) input.value = ''
      })
    },
    openDocPreview(files) {
      const urls = this.normalizeFileList(files)
      if (!urls.length) return
      this.previewImageUrls = urls
      this.showDocPreviewModal = true
    },
    copyToClipboard(text) {
      if (!text || text === '-') return
      const el = document.createElement('textarea');
      el.value = text;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      this.$vs.notify({ title: 'Copied', text, color: 'success', position: 'top-center' })
    },
    async loadSaraiOptions() {
      try {
        const { data } = await axios.get('/admin/sarai', {
          params: {
            ...(this.gurudwaraId ? { gurudwara: this.gurudwaraId } : {}),
            limit: 100
          }
        })
        if (data.success) {
          this.saraiOptions = data.data.results.map(s => ({
            label: (s.property_name || s.name || '').trim(),
            value: s._id
          }))
        }
      } catch (e) {
        console.error(e)
      }
    },
    async loadBookingCounts() {
      try {
        const params = {}
        if (this.gurudwaraId) params.gurudwara = this.gurudwaraId
        if (this.filterSarai) params.sarai = this.filterSarai
        if (this.filterDate) params.date = this.filterDate
        if (this.filterUser) params.user = this.filterUser

        const { data } = await axios.get('/admin/sarai/bookings/counts', { params })
        if (data.success) {
          this.totalCounts = {
            pending: data.data.pending || 0,
            confirmed: data.data.confirmed || 0,
            rejected: data.data.rejected || 0,
            cancelled: data.data.cancelled || 0,
            refunded: data.data.refunded || 0,
            completed: data.data.completed || 0
          }
        }
      } catch (e) {
        console.error('Error loading booking counts:', e)
      }
    },
    async loadBookings() {
      this.loading = true
      // Reset current list
      this.bookings[this.currentStatus] = []

      try {
        const params = {
          status: this.currentStatus,
          limit: 50,
          page: 1
        }
        if (this.gurudwaraId) params.gurudwara = this.gurudwaraId

        if (this.filterSarai) params.sarai = this.filterSarai
        if (this.filterDate) params.date = this.filterDate
        if (this.filterUser) params.user = this.filterUser

        // Use the generic route we verified
        const { data } = await axios.get(`/admin/sarai/bookings`, { params })

        if (data.success) {
          this.bookings[this.currentStatus] = data.data.results.map((b) => this.mapBookingRow(b))
          this.applyNewBookingHighlights(this.bookings[this.currentStatus])
          // Refresh all tab counts
          this.loadBookingCounts()
        }
      } catch (e) {
        console.error(e)
        this.$vs.notify({
          title: 'Error',
          text: 'Failed to load bookings',
          color: 'danger'
        })
      } finally {
        this.loading = false
      }
    },
    mapBookingRow(b) {
      return {
        _id: b._id,
        selected: false,
        dateRange: this.formatDateRange(b.check_in_date, b.check_out_date),
        amount: `Rs. ${(b.total_amount || 0).toFixed(2)}`,
        status: this.getBookingDisplayStatus(b),
        createdAt: b.createdAt || b.created_at || null,
        userName: b.user ? `${(b.user.first_name || '').trim()} ${(b.user.last_name || '').trim()}`.trim() || 'Guest User' : 'Unknown User',
        sangatId: b.user ? b.user.handle_name : '-',
        email: b.user ? b.user.email : '-',
        phone: b.user ? b.user.mobile_number : (b.alternate_mobile_number || '-'),
        bookingDate: `${moment(b.check_in_date).format('DD-MM-YYYY HH:mm A')} - ${moment(b.check_out_date).format('DD-MM-YYYY HH:mm A')}`,
        bookingId: b.booking_id || (b._id ? b._id.toString().toUpperCase().substring(0, 12) : '-'),
        saraiName: b.sarai ? b.sarai.name : '-',
        location: b.sarai ? b.sarai.description : '-',
        image: (b.sarai && b.sarai.images && b.sarai.images.length > 0) ? b.sarai.images[0] : null,
        rawData: b
      }
    },
    async openLinkedBooking() {
      const bookingId = this.$route.query && this.$route.query.booking
      if (!bookingId || this.dialogOnly) return
      const openKey = `${bookingId}:${this.$route.query.open || ''}`
      if (this.linkedBookingKey === openKey && this.showDetailPanel) return
      this.linkedBookingKey = openKey
      try {
        const { data } = await axios.get('/admin/sarai/bookings', {
          params: {
            booking: bookingId,
            limit: 1,
            ...(this.gurudwaraId ? { gurudwara: this.gurudwaraId } : {})
          }
        })
        const booking = data && data.success && data.data && data.data.results && data.data.results[0]
        if (!booking) {
          this.$vs.notify({ title: 'Booking', text: 'This sarai booking could not be opened', color: 'warning', position: 'top-center' })
          return
        }
        const mapped = this.mapBookingRow(booking)
        const statuses = ['pending', 'confirmed', 'rejected', 'cancelled', 'refunded']
        const statusIndex = statuses.indexOf(this.getBookingDisplayStatus(mapped))
        if (statusIndex >= 0 && this.activeTab !== statusIndex) {
          this.activeTab = statusIndex
        }
        this.openDetailPanel(mapped)
      } catch (error) {
        console.error(error)
        this.$vs.notify({ title: 'Booking', text: 'Failed to open this sarai booking', color: 'danger', position: 'top-center' })
      }
    },
    goBackToSaraiDetails() {
      if (!this.gurudwaraId || (this.$route.query && this.$route.query.from === 'list')) {
        this.$router.push('/gurudwara/list').catch(() => {})
        return
      }
      this.$router.push({
        path: `/gurudwara/${this.gurudwaraId}/edit`,
        query: { tab: 'sarai' }
      })
    },
    async resolvePortalGurudwaraId() {
      let id = resolveGurudwaraIdFromContext(this)
      if (!id) {
        await this.$store.dispatch('adminNotifications/ensureDefaultGurudwaraId')
        id = resolveGurudwaraIdFromContext(this)
      }
      this.resolvedGurudwaraId = id
    },
    async openNewBookingModal() {
      if (!this.gurudwaraId) {
        await this.resolvePortalGurudwaraId()
      }
      if (!this.gurudwaraId) {
        this.$vs.notify({
          title: 'Error',
          text: 'Could not determine your gurudwara. Please open this page from your gurudwara profile.',
          color: 'danger',
          position: 'top-center'
        })
        return
      }
      this.showNewBookingModal = true
      this.isNewBookingMinimized = false
      this.lockBodyScroll()
      this.resetBookingData()
    },
    toggleNewBookingMinimize() {
      this.isNewBookingMinimized = !this.isNewBookingMinimized
    },
    closeNewBookingModal() {
      this.showNewBookingModal = false
      this.isNewBookingMinimized = false
      this.unlockBodyScroll()
      this.finishDialogOnlyIfIdle()
    },
    toggleSaraiSelectionMinimize() {
      this.isSaraiSelectionMinimized = !this.isSaraiSelectionMinimized
    },
    closeSaraiSelectionModal() {
      this.showSaraiSelectionModal = false
      this.isSaraiSelectionMinimized = false
      this.finishDialogOnlyIfIdle()
    },
    finishDialogOnlyIfIdle() {
      if (!this.dialogOnly) return
      if (!this.showNewBookingModal && !this.showSaraiSelectionModal) {
        this.$emit('close')
      }
    },
    resetBookingData() {
      this.newBooking = {
        userId: null,
        dateRange: null,
        guests: { adults: 1, children: 0, infants: 0, pets: 0 },
        collectDocuments: false,
        documents: [
          {
            document_name: 'Passport',
            uploadHint: 'Upload both front and back side together.',
            isRequired: true,
            isEditing: false
          },
          {
            document_name: 'PAN Card',
            uploadHint: 'Upload both front and back side together.',
            isRequired: true,
            isEditing: false
          },
          {
            document_name: 'Aadhaar Card',
            uploadHint: 'Upload both front and back side together.',
            isRequired: true,
            isEditing: false
          }
        ],
        saraiId: null,
        selectedRooms: []
      }
      this.availableRooms = []
      this.roomOptions = []
    },
    openSaraiSelectionModal() {
      // Validation before opening sarai selection modal
      if (!this.newBooking.userId) {
        this.$vs.notify({
          title: 'Required',
          text: 'Please select a user',
          color: 'warning'
        })
        return
      }
      if (!this.newBooking.dateRange) {
        this.$vs.notify({
          title: 'Required',
          text: 'Please select check-in and check-out dates',
          color: 'warning'
        })
        return
      }
      const totalGuests = this.getTotalGuests()
      if (totalGuests === 0) {
        this.$vs.notify({
          title: 'Required',
          text: 'Please add at least one guest',
          color: 'warning'
        })
        return
      }

      // Close first modal and open second modal
      this.showNewBookingModal = false
      this.showSaraiSelectionModal = true
      this.newBooking.saraiId = null
      this.availableRooms = []
      this.newBooking.selectedRooms = []
    },
    // Document management methods
    handleDocCardClick(idx, event) {
      if (!this.newBooking.documents[idx].isEditing) {
        // Do nothing if not in edit mode
                
      }
    },
    editDocument(idx) {
      // Set all documents to non-editing mode first
      this.newBooking.documents.forEach(doc => {
        doc.isEditing = false
      })
      // Set this document to editing mode
      this.newBooking.documents[idx].isEditing = true
      // Focus the input after Vue updates the DOM
      this.$nextTick(() => {
        const inputRef = this.$refs[`docInput-${idx}`]
        if (inputRef && inputRef[0]) {
          inputRef[0].focus()
        }
      })
    },
    finishEditingDocument(idx) {
      this.newBooking.documents[idx].isEditing = false
    },
    deleteDocument(idx) {
      this.newBooking.documents.splice(idx, 1)
    },
    addNewDocument() {
      const newDoc = {
        document_name: '',
        uploadHint: 'Upload both front and back side together.',
        isRequired: true,
        isEditing: true
      }
      this.newBooking.documents.push(newDoc)
      // Focus the new document input
      this.$nextTick(() => {
        const idx = this.newBooking.documents.length - 1
        const inputRef = this.$refs[`docInput-${idx}`]
        if (inputRef && inputRef[0]) {
          inputRef[0].focus()
        }
      })
    },
    validateBookingBeforeSubmit() {
      if (!this.newBooking.userId) {
        this.$vs.notify({
          title: 'Required',
          text: 'Please select a user',
          color: 'warning'
        })
        return false
      }
      if (!this.newBooking.dateRange) {
        this.$vs.notify({
          title: 'Required',
          text: 'Please select check-in and check-out dates',
          color: 'warning'
        })
        return false
      }
      const totalGuests = this.getTotalGuests()
      if (totalGuests === 0) {
        this.$vs.notify({
          title: 'Required',
          text: 'Please add at least one guest',
          color: 'warning'
        })
        return false
      }
      if (!this.newBooking.saraiId) {
        this.$vs.notify({
          title: 'Required',
          text: 'Please select a sarai',
          color: 'warning'
        })
        return false
      }
      if (!this.isSelectionComplete) {
        this.$vs.notify({
          title: 'Required',
          text: this.newBooking.selectedRooms.length === 0 ? 'Please select at least one room' : 'Please select room options for all selected rooms',
          color: 'warning'
        })
        return false
      }

      const totalBookingGuests = (this.newBooking.guests.adults || 0) + (this.newBooking.guests.children || 0)
      let totalMaxCapacity = 0

      for (const selRoom of this.newBooking.selectedRooms) {
        const room = this.availableRooms.find(r => r.id === selRoom.room_id)
        if (!room) continue

        let capacity = 0
        if (room.options && room.options.length > 0 && selRoom.option_idx !== null) {
          capacity = room.options[selRoom.option_idx].capacity || 1
        } else {
          capacity = room.capacity || 1
        }
        totalMaxCapacity += capacity * selRoom.number_of_rooms
      }

      if (totalBookingGuests > totalMaxCapacity) {
        this.$vs.notify({
          title: 'Capacity Exceeded',
          text: `Total guests (${totalBookingGuests}) exceed the maximum capacity for selected rooms (${totalMaxCapacity})`,
          color: 'warning'
        })
        return false
      }

      return true
    },
    confirmBooking() {
      if (!this.validateBookingBeforeSubmit()) return
      this.createBooking()
    },
    sendPaymentRequestLink() {
      if (!this.featureFlags.enablePaymentGateway) return
      if (!this.validateBookingBeforeSubmit()) return
      this.createBooking()
    },

    incrementGuest(type) {
      this.newBooking.guests[type]++
    },
    decrementGuest(type) {
      if (this.newBooking.guests[type] > 0) {
        this.newBooking.guests[type]--
      }
    },
    goBackToNewBooking() {
      this.showSaraiSelectionModal = false
      this.showNewBookingModal = true
      this.isNewBookingMinimized = false
    },
    getTotalGuests() {
      const { adults, children, infants } = this.newBooking.guests
      return adults + children + infants
    },


    async loadRooms() {
      if (!this.newBooking.saraiId) return

      try {
        this.$vs.loading()
        const { data } = await axios.get(`/admin/sarai/${this.newBooking.saraiId}`)

        if (data.success && data.data) {
          this.availableRooms = data.data.rooms.map(room => ({
            id: room._id,
            name: room.room_type,
            roomsLeft: room.number_of_rooms || 0,
            originalCapacity: room.number_of_rooms || 0, // Store original capacity
            image: room.images && room.images.length > 0 ? room.images[0] : null,
            description: room.description,
            price: room.price_per_night || 0,
            taxes: room.taxes_and_fees || 0,
            options: room.options || [],
            amenities: room.amenities || []
          }))

          // If we have dates selected, fetch availability immediately
          if (this.newBooking.dateRange) {
            await this.updateAvailability()
          }
        }
        this.$vs.loading.close()
      } catch (error) {
        this.$vs.loading.close()
        console.error('Error loading rooms:', error)
      }
    },

    async updateAvailability() {
      if (!this.newBooking.saraiId || !this.newBooking.dateRange || this.availableRooms.length === 0) return

      const dates = this.newBooking.dateRange.split(' to ')
      if (dates.length !== 2) return

      const start = dates[0]
      const end = dates[1]

      try {
        // Fetch dashboard stats for availability
        const { data } = await axios.get(`/admin/sarai/${this.newBooking.saraiId}/dashboard`, {
          params: {
            startDate: start,
            endDate: end
          }
        })

        if (data.success && data.data && data.data.room_details) {
          const roomStats = data.data.room_details

          // Update availableRooms with correct availability
          this.availableRooms.forEach(room => {
            const stat = roomStats.find(s => s.room_id === room.id)
            if (stat) {
              room.roomsLeft = stat.available_rooms
            } else {
              // Fallback if stat not found
              room.roomsLeft = room.originalCapacity
            }
          })

          // If currently selected rooms now have 0 availability or quantity > availability, adjust selection
          if (this.newBooking.selectedRooms.length > 0) {
            const roomsToRemove = []
            this.newBooking.selectedRooms.forEach(selRoom => {
              const room = this.availableRooms.find(r => r.id === selRoom.room_id)
              if (!room || room.roomsLeft <= 0) {
                roomsToRemove.push(selRoom.room_id)
              } else if (selRoom.number_of_rooms > room.roomsLeft) {
                selRoom.number_of_rooms = room.roomsLeft
                this.$vs.notify({
                  title: 'Availability Updated',
                  text: `${room.name} has only ${room.roomsLeft} rooms available for these dates.`,
                  color: 'warning'
                })
              }
            })

            if (roomsToRemove.length > 0) {
              this.newBooking.selectedRooms = this.newBooking.selectedRooms.filter(r => !roomsToRemove.includes(r.room_id))
              this.$vs.notify({
                title: 'Availability Changed',
                text: 'Some selected rooms are no longer available for these dates and have been removed.',
                color: 'warning'
              })
            }
          }
        }
      } catch (error) {
        console.error('Error checking availability:', error)
      }
    },

    selectRoom(room) {
      const index = this.newBooking.selectedRooms.findIndex(r => r.room_id === room.id)
      if (index > -1) {
        // Remove if already selected (toggle)
        this.newBooking.selectedRooms.splice(index, 1)
      } else {
        // Add to selection
        this.newBooking.selectedRooms.push({
          room_id: room.id,
          number_of_rooms: 1,
          option_id: null,
          option_idx: null
        })
      }
    },

    incrementRoomQuantity(room) {
      const selRoom = this.newBooking.selectedRooms.find(r => r.room_id === room.id)
      if (selRoom && selRoom.number_of_rooms < room.roomsLeft) {
        selRoom.number_of_rooms++
      }
    },

    decrementRoomQuantity(room) {
      const index = this.newBooking.selectedRooms.findIndex(r => r.room_id === room.id)
      if (index === -1) return

      const selRoom = this.newBooking.selectedRooms[index]
      if (selRoom.number_of_rooms > 1) {
        selRoom.number_of_rooms--
      } else {
        // If decrementing from 1, deselect room
        this.newBooking.selectedRooms.splice(index, 1)
      }
    },

    resetSelection() {
      this.newBooking.selectedRooms = []
    },
    async createBooking() {
      if (!this.newBooking.dateRange) return

      const dates = this.newBooking.dateRange.split(' to ')
      if (dates.length !== 2) {
        this.$vs.notify({
          title: 'Invalid Dates',
          text: 'Please select a valid date range',
          color: 'warning'
        })
        return
      }

      const checkInDate = dates[0]
      const checkOutDate = dates[1]

      let calculatedTax = 0
      let calculatedRoomCharge = 0

      this.newBooking.selectedRooms.forEach(sr => {
        const room = this.availableRooms.find(r => r.id === sr.room_id)
        if (!room) return

        let unitPrice = 0
        if (sr.option_id && room.options) {
          const opt = room.options.find(o => o._id === sr.option_id)
          unitPrice = opt ? opt.price : room.price
        } else {
          unitPrice = room.price
        }

        calculatedTax += parseFloat(this.getTotalTaxAmount(unitPrice)) * sr.number_of_rooms
        calculatedRoomCharge += unitPrice * sr.number_of_rooms
      })

      const payload = {
        user_id: this.newBooking.userId,
        sarai_id: this.newBooking.saraiId,
        check_in_date: checkInDate,
        check_out_date: checkOutDate,
        guests: this.newBooking.guests,
        rooms: this.newBooking.selectedRooms.map(selRoom => ({
          room_id: selRoom.room_id,
          option_id: selRoom.option_id,
          number_of_rooms: selRoom.number_of_rooms
        })),
        collect_documents: this.newBooking.collectDocuments,
        requested_documents: this.newBooking.collectDocuments
          ? this.newBooking.documents.map(doc => ({
            document_name: doc.document_name,
            is_required: doc.isRequired,
            upload_hint: doc.uploadHint
          }))
          : [],
        // Added missing pricing fields as requested
        room_charge_per_night: parseFloat(calculatedRoomCharge.toFixed(2)),
        tax_amount: parseFloat(calculatedTax.toFixed(2)),
        total_amount: this.totalBookingAmount
      }

      try {
        this.$vs.loading()
        const { data } = await axios.post('/admin/sarai/bookings/create', payload)
        this.$vs.loading.close()

        if (data.success) {
          this.$vs.notify({
            title: 'Success',
            text: this.featureFlags.enablePaymentGateway
              ? `Payment request of INR ${this.formatPrice(this.totalBookingAmount)} sent successfully`
              : `Booking confirmed successfully (INR ${this.formatPrice(this.totalBookingAmount)})`,
            color: 'success'
          })
          this.showSaraiSelectionModal = false
          this.showNewBookingModal = false
          const created = data.data || {}
          this.queueBookingHighlight(created._id || created.id)
          this.activeTab = 0
          if (!this.dialogOnly) {
            this.loadBookings()
            this.loadBookingCounts()
          }
          this.finishDialogOnlyIfIdle()
        }
      } catch (error) {
        this.$vs.loading.close()
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.message || 'Something went wrong',
          color: 'danger'
        })
      }
    },
    getSelectedSaraiName() {
      const sarai = this.saraiOptions.find(s => s.value === this.newBooking.saraiId)
      return sarai ? sarai.label : '-'
    },
    getSelectedRoomName() {
      if (this.newBooking.selectedRooms.length === 0) return '-'
      return this.newBooking.selectedRooms.map(selRoom => {
        const room = this.availableRooms.find(r => r.id === selRoom.room_id)
        return room ? room.name : '-'
      }).join(', ')
    },
    getSelectedOptionTitle() {
      if (this.newBooking.selectedRooms.length === 0) return 'Standard'
      return this.newBooking.selectedRooms.map(selRoom => {
        const room = this.availableRooms.find(r => r.id === selRoom.room_id)
        if (room && room.options && selRoom.option_idx !== null) {
          const opt = room.options[selRoom.option_idx]
          return opt ? opt.name : 'Standard'
        }
        return 'Standard'
      }).join(', ')
    },
    async shareRoom(room) {
      const saraiName = this.getSelectedSaraiName()
      const dateRangeText = this.newBooking.dateRange ? ` for ${this.newBooking.dateRange}` : ''
      const shareText = `Check out this room at ${saraiName}:
Room: ${room.name}
Price: Rs. ${room.price} per night
Availability: ${room.roomsLeft} rooms left${dateRangeText}

Shared from Sangat App.`

      if (navigator.share) {
        try {
          await navigator.share({
            title: `${room.name} at ${saraiName}`,
            text: shareText,
            url: window.location.href
          })
        } catch (err) {
          if (err.name !== 'AbortError') {
            console.error('Error sharing:', err)
          }
        }
      } else {
        // Fallback to clipboard
        this.copyToClipboard(shareText)
      }
    },
    formatAmenityName(val) {
      if (!val) return ''
      return val.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
    },
    getSelectedRoom(roomId) {
      return this.newBooking.selectedRooms.find(sr => sr.room_id === roomId)
    },
    getCalculatedTax(pricePerNight) {
      const nights = this.numberOfNights
      if (nights === 0) return 0
      const totalRoomCharge = pricePerNight * nights
      // 5% if <= 7500, else 18%
      const rate = totalRoomCharge <= 7500 ? 0.05 : 0.18
      const totalTax = totalRoomCharge * rate
      // Return tax per night
      return (totalTax / nights).toFixed(2)
    },
    getTotalTaxAmount(pricePerNight) {
      const nights = this.numberOfNights
      if (nights === 0) return 0
      const totalRoomCharge = pricePerNight * nights
      const rate = totalRoomCharge <= 7500 ? 0.05 : 0.18
      return (totalRoomCharge * rate).toFixed(2)
    },
    getTaxPercentage(pricePerNight) {
      const nights = this.numberOfNights
      if (nights === 0) return 0
      const totalRoomCharge = pricePerNight * nights
      return totalRoomCharge <= 7500 ? 5 : 18
    },
    formatPrice(value) {
      const val = parseFloat(value)
      if (isNaN(val)) return '0.00'
      // Format number to Indian locale with comma separation and 2 decimal places
      return val.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    // Detail Panel Methods
    openDetailPanel(booking) {
      console.log('Opening detail panel for:', booking)
      if (!booking) return
      this.selectedBooking = booking
      try {
        this.documents = this.buildDocumentsFromBooking(booking)
        this.originalDocuments = JSON.parse(JSON.stringify(this.documents))
        this.requestedDocuments = this.buildRequestedDocumentsFromBooking(booking)
        this.originalRequestedDocuments = JSON.parse(JSON.stringify(this.requestedDocuments))
      } catch (error) {
        console.error('Failed to prepare sarai booking details', error)
        this.documents = []
        this.originalDocuments = []
        this.requestedDocuments = []
        this.originalRequestedDocuments = []
      }
      this.deletedRequestedDocIds = []
      this.newDocuments = []
      this.documentsModified = false
      this.showDetailPanel = true
      this.isPanelMinimized = false
      this.lockBodyScroll()
      this.$nextTick(() => {
        const el = this.$refs.detailOverlay
        if (el && el.parentNode !== document.body) {
          document.body.appendChild(el)
        }
      })
    },
    closeDetailPanel() {
      if (this.documentsModified) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'warning',
          title: 'Unsaved Changes',
          text: 'You have unsaved changes. Are you sure you want to close?',
          acceptText: 'Close Anyway',
          cancelText: 'Cancel',
          accept: () => {
            this.closeAllPanels()
          }
        })
      } else {
        this.closeAllPanels()
      }
    },
    closeAllPanels() {
      this.showDetailPanel = false
      this.isPanelMinimized = false
      this.selectedBooking = null
      this.showStatusMenu = false
      this.documentsModified = false
      this.unlockBodyScroll()
    },
    togglePanelMinimize() {
      this.isPanelMinimized = !this.isPanelMinimized
      if (this.isPanelMinimized) {
        this.unlockBodyScroll()
      } else {
        this.lockBodyScroll()
      }
    },
    async refreshBookingDetails() {
      if (!this.selectedBooking) return
      try {
        this.$vs.loading({ container: '.detail-panel', scale: 0.6 })
        await this.loadBookings()
        const updated = this.bookings[this.currentStatus].find(b => b._id === this.selectedBooking._id)
        if (updated) {
          this.selectedBooking = updated
          this.documents = this.buildDocumentsFromBooking(updated)
          this.originalDocuments = JSON.parse(JSON.stringify(this.documents))
          this.requestedDocuments = this.buildRequestedDocumentsFromBooking(updated)
          this.originalRequestedDocuments = JSON.parse(JSON.stringify(this.requestedDocuments))
          this.deletedRequestedDocIds = []
          this.documentsModified = false
        }
        this.$vs.notify({ title: 'Success', text: 'Details refreshed', color: 'success', position: 'top-center' })
      } catch (e) {
        console.error(e)
      } finally {
        this.$vs.loading.close('.detail-panel > .con-vs-loading')
      }
    },
    async openPaymentRequestPanel() {
      if (!this.featureFlags.enablePaymentGateway) return
      if (!this.selectedBooking) return

      if (!this.hasDocsApproved(this.selectedBooking)) {
        this.$vs.notify({
          title: 'Documents Required',
          text: 'Please approve all required documents before sending a payment request.',
          color: 'warning',
          position: 'top-center'
        })
        return
      }

      try {
        this.$vs.loading({ container: '.detail-panel', scale: 0.6 })
        const { data } = await axios.post(`/admin/sarai/bookings/${this.selectedBooking._id}/send-payment-request`)
        if (data.success) {
          this.$vs.notify({
            title: 'Success',
            text: `Payment request of ${this.selectedBooking.amount} sent successfully`,
            color: 'success',
            position: 'top-center'
          })
          // Close the detail panel after successful payment request
          this.closeAllPanels()
        }
      } catch (e) {
        console.error(e)
        this.$vs.notify({
          title: 'Error',
          text: e.response.data.message || 'Failed to send payment request',
          color: 'danger',
          position: 'top-center'
        })
      } finally {
        this.$vs.loading.close('.detail-panel > .con-vs-loading')
      }
    },
    hasDocsApproved(booking) {
      if (!booking || !booking.rawData) return false
      const requestedDocs = booking.rawData.requested_documents || []
      const uploadedDocs = booking.rawData.uploaded_documents || []

      // If no documents are requested, it's considered approved
      if (requestedDocs.length === 0) return true

      // Filter for required documents
      const requiredDocNames = requestedDocs
        .filter(doc => doc.is_required)
        .map(doc => doc.document_name)

      if (requiredDocNames.length === 0) return true

      // Check if all required documents are uploaded AND accepted
      return requiredDocNames.every(name => {
        const uploaded = uploadedDocs.find(d => d.document_name === name)
        return uploaded && uploaded.status === 'accepted'
      })
    },
    buildDocumentsFromBooking(booking) {
      if (!booking || !booking.rawData) return []
      const uploaded = booking.rawData.uploaded_documents || []
      const requested = booking.rawData.requested_documents || []

      return uploaded.map(doc => {
        const reqInfo = requested.find(r => r.document_name === doc.document_name) || {}
        return {
          key: doc._id || Math.random().toString(36).substr(2, 9),
          document_name: doc.document_name,
          file_urls: doc.file_urls || [],
          status: doc.status || 'pending',
          rejectionReason: doc.rejection_reason || '',
          isRequired: reqInfo.is_required !== false,
          // Store original for comparison if needed
          originalStatus: doc.status
        }
      })
    },
    buildRequestedDocumentsFromBooking(booking) {
      if (!booking || !booking.rawData) return []
      const requested = booking.rawData.requested_documents || []
      const uploadedNames = (booking.rawData.uploaded_documents || []).map(d => d.document_name)

      return requested
        .filter(doc => !uploadedNames.includes(doc.document_name))
        .map(doc => ({
          _id: doc._id, // Keep the original ID
          document_name: doc.document_name,
          isRequired: doc.is_required !== false,
          uploadHint: doc.description || doc.upload_hint || '',
          isEditing: false,
          isSaved: true // Mark as saved
        }))
    },
    setDocumentStatus(key, status) {
      this.documents = this.documents.map(doc => {
        if (doc.key === key) {
          return { ...doc, status }
        }
        return doc
      })
      this.documentsModified = true
      this.checkDocumentsModified()
    },
    addRequestedDocument() {
      this.newDocuments.push({
        document_name: 'Aadhaar Card',
        isRequired: true,
        isEditing: false,
        uploadHint: 'Upload both front and back side together.'
      })
      this.checkDocumentsModified()
    },
    editNewDocument(idx) {
      if (this.newDocuments[idx]) {
        this.newDocuments.forEach((doc, i) => {
          if (i !== idx && doc.isEditing) doc.isEditing = false
        })
        this.newDocuments[idx].isEditing = true
        this.checkDocumentsModified()
      }
    },
    handleNewDocCardClick(idx, event) {
      if (event.target.closest('.doc-action-btn') || event.target.closest('.new-doc-edit-form')) return
      if (this.newDocuments[idx] && this.newDocuments[idx].isEditing) {
        this.finishEditingNewDocument(idx)
      }
    },
    finishEditingNewDocument(idx) {
      if (this.newDocuments[idx]) {
        this.newDocuments[idx].isEditing = false
        this.checkDocumentsModified()
      }
    },
    deleteNewDocument(idx) {
      this.newDocuments.splice(idx, 1)
      this.checkDocumentsModified()
    },
    editRequestedDocument(idx) {
      if (this.requestedDocuments[idx]) {
        this.requestedDocuments.forEach((doc, i) => {
          if (i !== idx && doc.isEditing) doc.isEditing = false
        })
        this.newDocuments.forEach((doc) => { if (doc.isEditing) doc.isEditing = false })
        this.requestedDocuments[idx].isEditing = true
        this.checkDocumentsModified()
      }
    },
    finishEditingRequestedDocument(idx) {
      if (this.requestedDocuments[idx]) {
        this.requestedDocuments[idx].isEditing = false
        this.checkDocumentsModified()
      }
    },
    handleRequestedDocCardClick(idx, event) {
      if (event.target.closest('.doc-action-btn') || event.target.closest('.new-doc-edit-form')) return
      if (this.requestedDocuments[idx] && this.requestedDocuments[idx].isEditing) {
        this.finishEditingRequestedDocument(idx)
      }
    },
    deleteRequestedDocument(idx) {
      const doc = this.requestedDocuments[idx]
      if (doc && doc._id) {
        this.deletedRequestedDocIds.push(doc._id)
      }
      this.requestedDocuments.splice(idx, 1)
      this.checkDocumentsModified()
    },
    checkDocumentsModified() {
      // 1. Check if uploaded documents status changed
      const statusChanged = this.documents.some((doc) => {
        const originalDoc = this.originalDocuments.find(od => od.key === doc.key)
        return originalDoc && (originalDoc.status !== doc.status || originalDoc.rejectionReason !== doc.rejectionReason)
      })

      // 2. Check if new documents are added
      const newDocsAdded = this.newDocuments.length > 0

      // 3. Check if requested documents changed (deleted or edited)
      const requestedDocsChanged = JSON.stringify(this.requestedDocuments) !== JSON.stringify(this.originalRequestedDocuments)
      const requestedDocsDeleted = this.deletedRequestedDocIds.length > 0

      this.documentsModified = statusChanged || newDocsAdded || requestedDocsChanged || requestedDocsDeleted
    },
    async saveBookingChanges() {
      if (!this.selectedBooking || !this.selectedBooking._id) return

      try {
        this.$vs.loading({ container: '.detail-panel', scale: 0.6 })

        const payload = {}

        // 1. Collect status changes for uploaded documents
        const documentStatuses = this.documents
          .filter(doc => {
            const originalDoc = this.originalDocuments.find(od => od.key === doc.key)
            return originalDoc && (originalDoc.status !== doc.status || originalDoc.rejectionReason !== doc.rejectionReason)
          })
          .map(doc => ({
            document_key: doc.key,
            status: doc.status,
            rejection_reason: doc.rejectionReason || ''
          }))

        if (documentStatuses.length > 0) {
          payload.document_statuses = documentStatuses
        }

        // 2. Collect deleted requested documents
        if (this.deletedRequestedDocIds.length > 0) {
          payload.deleted_requested_document_ids = [...this.deletedRequestedDocIds]
        }

        // 3. Collect updated requested documents (those that were edited)
        const updatedRequested = this.requestedDocuments
          .filter(doc => {
            if (!doc._id) return false
            const originalDoc = this.originalRequestedDocuments.find(od => od._id === doc._id)
            return originalDoc && (
              originalDoc.document_name !== doc.document_name ||
                            originalDoc.isRequired !== doc.isRequired ||
                            originalDoc.uploadHint !== doc.uploadHint
            )
          })
          .map(doc => ({
            _id: doc._id,
            document_name: doc.document_name,
            is_required: doc.isRequired,
            description: doc.uploadHint || ''
          }))

        if (updatedRequested.length > 0) {
          payload.updated_requested_documents = updatedRequested
        }

        // 4. Collect brand new document requests
        if (this.newDocuments.length > 0) {
          payload.new_document_requests = this.newDocuments.map(doc => ({
            document_name: doc.document_name,
            is_required: doc.isRequired,
            description: doc.uploadHint || ''
          }))
        }

        if (Object.keys(payload).length === 0) {
          this.$vs.notify({ title: 'No Changes', text: 'There are no changes to save', color: 'warning', position: 'top-center' })
          this.$vs.loading.close('.detail-panel > .con-vs-loading')
          return
        }

        await axios.patch(`/admin/sarai/bookings/${this.selectedBooking._id}`, payload)

        this.$vs.notify({ title: 'Success', text: 'Booking changes saved successfully', color: 'success', position: 'top-center' })
        this.documentsModified = false
        this.newDocuments = []
        this.deletedRequestedDocIds = []
        await this.refreshBookingDetails()
        this.closeAllPanels()
      } catch (error) {
        console.error('Error saving booking changes:', error)
        const errorMsg = error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : (error.message || 'Failed to save changes')
        this.$vs.notify({ title: 'Error', text: errorMsg, color: 'danger', position: 'top-center' })
      } finally {
        this.$vs.loading.close('.detail-panel > .con-vs-loading')
      }
    },
    toggleStatusMenu() {
      this.showStatusMenu = !this.showStatusMenu
      if (this.showStatusMenu) {
        document.addEventListener('click', this.onOutsideStatusClick, true)
      } else {
        document.removeEventListener('click', this.onOutsideStatusClick, true)
      }
    },
    onOutsideStatusClick(e) {
      const root = this.$refs && this.$refs.statusActionRef
      if (root && !root.contains(e.target)) {
        this.showStatusMenu = false
        document.removeEventListener('click', this.onOutsideStatusClick, true)
      }
    },
    async applyStatusChange(status) {
      if (!this.selectedBooking) return
      this.showStatusMenu = false

      if (status === 'Refunded' && !this.selectedPaymentReceived) {
        this.$vs.notify({
          title: 'Payment not received',
          text: 'Mark as Refunded is available only after payment is received.',
          color: 'warning',
          position: 'top-center'
        })
        return
      }

      if (status === 'Cancelled' || status === 'Rejected') {
        this.pendingStatusAction = status
        this.rejectionReason = ''
        this.reasonModalTitle = `Reason for ${status === 'Rejected' ? 'Rejection' : 'Cancellation'}`
        this.reasonModalDescription = status === 'Cancelled'
          ? (this.selectedPaymentReceived
            ? 'Payment was received. Set the cancellation charge and how much to refund. The guest will be notified with these details.'
            : 'Payment has not been received, so no refund is due. Please provide a reason for cancellation.')
          : 'Please provide a reason for rejecting this booking. This reason will be sent to the user via notification.'
        this.reasonConfirmButtonText = status === 'Rejected' ? 'Confirm Rejection' : 'Confirm Cancellation'
        if (status === 'Cancelled' && this.selectedPaymentReceived) {
          this.initializeCancellationRefund()
        } else {
          this.cancellationCharge = 0
          this.refundAmount = 0
        }
        this.showReasonModal = true
      } else {
        await this.executeStatusChange(status)
      }
    },
    initializeCancellationRefund() {
      const booking = (this.selectedBooking && this.selectedBooking.rawData) || {}
      const total = Number(booking.total_amount) || 0
      const checkIn = booking.check_in_date
      const suggested = this.getSuggestedCancellationRefund(total, checkIn)

      this.bookingTotalAmount = total
      this.daysUntilCheckIn = suggested.daysUntilCheckIn
      this.cancellationChargePercentage = suggested.chargePercentage
      this.cancellationCharge = suggested.cancellationCharge
      this.refundAmount = suggested.refundAmount
    },
    getSuggestedCancellationRefund(totalAmount, checkInDate) {
      const total = Number(totalAmount) || 0
      const checkIn = moment(checkInDate)
      const today = moment().startOf('day')
      const daysUntilCheckIn = checkIn.isValid() ? checkIn.diff(today, 'days') : 0

      let chargePercentage = 0
      if (daysUntilCheckIn <= 0) chargePercentage = 100
      else if (daysUntilCheckIn <= 1) chargePercentage = 50
      else if (daysUntilCheckIn <= 3) chargePercentage = 25
      else if (daysUntilCheckIn <= 7) chargePercentage = 10

      const cancellationCharge = Math.round(((total * chargePercentage) / 100) * 100) / 100
      const refundAmount = Math.max(0, Math.round((total - cancellationCharge) * 100) / 100)

      return { daysUntilCheckIn, chargePercentage, cancellationCharge, refundAmount }
    },
    applyCancellationPreset(percentage) {
      const total = Number(this.bookingTotalAmount) || 0
      const charge = Math.round(((total * percentage) / 100) * 100) / 100
      this.cancellationChargePercentage = percentage
      this.cancellationCharge = charge
      this.refundAmount = Math.max(0, Math.round((total - charge) * 100) / 100)
    },
    updateRefundFromCharge() {
      const total = Number(this.bookingTotalAmount) || 0
      let charge = Number(this.cancellationCharge) || 0
      if (charge < 0) charge = 0
      if (charge > total) charge = total
      this.cancellationCharge = charge
      this.cancellationChargePercentage = total > 0 ? Math.round((charge / total) * 100) : 0
      this.refundAmount = Math.max(0, Math.round((total - charge) * 100) / 100)
    },
    closeReasonModal() {
      this.showReasonModal = false
      this.rejectionReason = ''
      this.pendingStatusAction = null
      this.cancellationCharge = 0
      this.refundAmount = 0
      this.bookingTotalAmount = 0
      this.cancellationChargePercentage = 0
      this.daysUntilCheckIn = null
    },
    confirmReasonSubmit() {
      if (!this.rejectionReason || !this.rejectionReason.trim()) {
        this.$vs.notify({
          title: 'Required',
          text: 'Please enter a reason',
          color: 'warning',
          position: 'top-center'
        })
        return
      }
      if (this.pendingStatusAction === 'Cancelled' && this.selectedPaymentReceived) {
        this.updateRefundFromCharge()
      }
      this.executeStatusChange(this.pendingStatusAction, this.rejectionReason)
      this.closeReasonModal()
    },
    async executeStatusChange(status, reason = null) {
      if (!this.selectedBooking) return
      const paymentReceived = this.selectedPaymentReceived
      const cancellationCharge = Number(this.cancellationCharge) || 0
      const refundAmount = Number(this.refundAmount) || 0
      try {
        const payload = { booking_status: status }
        if (reason) payload.rejection_reason = reason
        if (status === 'Cancelled' && paymentReceived) {
          payload.cancellation_charge = cancellationCharge
          payload.refund_amount = refundAmount
        }

        await axios.put(`/admin/sarai/bookings/status/${this.selectedBooking._id}`, payload)

        const nextStatus = (status || '').toLowerCase()
        this.selectedBooking.status = nextStatus
        if (this.selectedBooking.rawData) {
          this.selectedBooking.rawData.status = nextStatus
        }
        this.showStatusMenu = false

        const successText = status === 'Cancelled' && paymentReceived
          ? `Booking cancelled. Charge: ₹${this.formatPrice(cancellationCharge)}, Refund: ₹${this.formatPrice(refundAmount)}`
          : `Booking marked as ${status}${reason ? ' with reason' : ''}`

        this.$vs.notify({
          title: 'Status Updated',
          text: successText,
          color: 'success',
          position: 'top-center',
          time: 2200
        })
        this.closeAllPanels()
        await this.loadBookings()
        await this.loadBookingCounts()
      } catch (e) {
        console.error(e)
        const message = (e && e.response && e.response.data && e.response.data.message) || 'Failed to update status'
        this.$vs.notify({ title: 'Error', text: message, color: 'danger', position: 'top-center', time: 2500 })
      }
    },
    openWhatsApp(phone) {
      if (!phone) return
      const cleanNumber = phone.replace(/[^\d]/g, '')
      window.open(`https://wa.me/${cleanNumber}`, '_blank')
    },
    lockBodyScroll() {
      document.body.style.overflow = 'hidden'
    },
    unlockBodyScroll() {
      document.body.style.overflow = 'auto'
    }
  }
}
</script>

<style scoped>
.sarai-bookings-page {
    background-color: var(--page-bg);
    color: var(--text-primary);
    height: 100vh;
    overflow: hidden;
}

.booking-list-scroll {
    height: calc(100vh - 230px);
    overflow-y: auto;
    padding-right: 10px;
    padding-bottom: 20px;
}

.booking-list-scroll::-webkit-scrollbar {
    width: 6px;
}

.booking-list-scroll::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 4px;
}

.booking-tabs ::v-deep .vs-search-inner {
    margin-left: 0;
}

.booking-tabs ::v-deep .vs-tabs--btn {
    font-size: 18px !important;
    font-weight: 600 !important;
}

.booking-tabs ::v-deep .vs-tabs--btn span {
    font-size: 18px !important;
    font-weight: 600;
}

.booking-card {
    border-radius: 20px;
    border: 1px solid var(--divider);
    background-color: var(--card-bg);
}

.booking-type-tag {
    background: #f3e8ff;
    color: #2c0146;
}

.new-booking-tag {
    background: #dcfce7;
    color: #166534;
}

.booking-card.is-new-booking {
    border: 2px solid #22c55e;
    animation: new-booking-pulse 1.1s ease-in-out 5;
}

@keyframes new-booking-pulse {
    0% {
        box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.5);
        border-color: #22c55e;
    }
    50% {
        box-shadow: 0 0 0 8px rgba(34, 197, 94, 0.12);
        border-color: #16a34a;
    }
    100% {
        box-shadow: 0 0 0 0 rgba(34, 197, 94, 0);
        border-color: #22c55e;
    }
}

.booking-card:hover {
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
}

/* Booking Info Grid */
.booking-info-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;
}

.info-item {
    display: flex;
    flex-direction: column;
    gap: 9px;
}

.info-label {
    font-size: 15px;
    font-weight: 700;
    color: var(--text-primary);
    min-width: 120px;
    white-space: nowrap;
}

.info-value {
    font-size: 16px;
    color: var(--text-primary);
}

.info-value-with-icon {
    display: flex;
    align-items: center;
    gap: 10px;
}

.info-value-with-icons {
    display: flex;
    align-items: center;
    gap: 10px;
}

.info-value-with-icon span,
.info-value-with-icons span {
    font-size: 16px;
    color: var(--text-primary);
}

/* Icons */
.copy-icon {
    color: var(--text-primary);
    cursor: pointer;
    transition: color 0.2s ease;
}


.whatsapp-icon {
    color: var(--text-primary);
    cursor: pointer;
    transition: color 0.2s ease;
}


/* User Name */
.user-name {
    font-size: 20px;
    font-weight: 700;
    color: var(--text-primary);
}

.tag.warning {
    background: #F7E9FF;
    color: #2C0146;
}

.tag.danger {
    background: #991b1b;
    color: #fff;
}

.tag {
    background: #f3f4f6;
    color: #374151;
    padding: 5px 10px;
    border-radius: 4px;
    font-size: 17px;
}

.action-buttons {
    display: flex;
    gap: 20px;
    align-items: center;
    margin-top: 24px;
    justify-content: space-between;
    padding: 24px 0px;
    border-top: 1px solid #f3f4f6;
}

.tag.success {
    background: #9CFF9C;
    color: #2C0146;
}

/* Responsive */
@media (max-width: 768px) {
    .booking-info-grid {
        grid-template-columns: 1fr;
    }

    .booking-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
        padding-bottom: 20px;
    }

    .booking-tags {
        width: 100%;
    }


    .action-buttons {
        flex-direction: column;
    }

    .info-row {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }

    .info-label {
        min-width: auto;
    }
}

/* Right Side Floating Modal Styles */
.detail-panel-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 52000;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 40px;
}

.detail-panel {
    background: var(--card-bg);
    color: var(--text-primary);
    width: 550px;
    max-height: 90vh;
    border-radius: 24px;
    display: flex;
    flex-direction: column;
    box-shadow: 0 10px 50px rgba(0, 0, 0, 0.2);
    border: 1px solid #000;
    animation: sideSlideIn 0.3s ease-out;
    position: relative;
    z-index: 2001;
    overflow: hidden;
}

@keyframes sideSlideIn {
    from {
        transform: translateX(50px);
        opacity: 0;
    }

    to {
        transform: translateX(0);
        opacity: 1;
    }
}

.panel-header {
    padding: 30px 40px;
    border-bottom: 1px solid var(--divider);
    display: flex;
    background: var(--card-bg);
}

.panel-title h3 {
    font-size: 28px;
    font-weight: 800;
    color: var(--text-primary);
    margin: 0;
}

.panel-controls {
    display: flex;
    gap: 30px;
}

.panel-content {
    flex: 1;
    overflow-y: auto;
    min-height: 0;
    /* Flexbox scroll fix */
}

.panel-content::-webkit-scrollbar {
    width: 6px;
}

.panel-content::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 4px;
}


.scrollable-modal-body {
    scrollbar-width: thin;
    scrollbar-color: #999 transparent;
    padding-bottom: 20px;
    overflow-y: auto !important;
}

::v-deep .vs-select--options {
    max-height: 280px;
    overflow-y: auto !important;
    z-index: 60001 !important;
}

::v-deep .open-item>.vs-collapse-item--content {
    max-height: none !important;
    overflow: visible !important;
}


.documents-section {
    padding-right: 12px;
}


.panel-footer-sticky {
    padding: 24px 40px 40px;
    background: var(--card-bg);
    border-top: 1px solid var(--divider);
    display: flex;
    gap: 16px;
}

/* Slot Chip - matches slotMaster.vue style */
.slot-chip {
    background: #EBF1FF;
    color: #0038FF;
    padding: 4px 12px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 700;
    display: inline-flex;
    align-items: center;
}

/* Minimized Panel */
.minimized-panel {
    position: fixed;
    bottom: 24px;
    right: 24px;
    width: 400px;
    background: var(--card-bg);
    color: var(--text-primary);
    border-radius: 16px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
    border: 1px solid #000;
    z-index: 3000;
}

.minimized-header {
    padding: 16px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.minimized-title h4 {
    margin: 0;
    font-weight: 700;
}

.minimized-controls {
    display: flex;
    gap: 16px;
}

/* Info Labels and Values */
.detail-panel .info-label {
    color: var(--text-secondary);
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 6px;
    display: block;
    min-width: unset;
}

.detail-panel .info-value {
    color: var(--text-primary) !important;
    font-weight: 700 !important;
    font-size: 16px !important;
}

/* Document section specific */
/* Document section specific */
.documents-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
    margin-bottom: 20px;
}

.document-card {
    background: var(--card-bg);
    border: 1px solid var(--divider);
    border-radius: 12px;
    padding: 16px;
    transition: all 0.3s ease;
}

.document-card.status-accepted {
    border-left: 6px solid #10b981;
}

.document-card.status-rejected {
    border-left: 6px solid #ef4444;
}

.document-card.status-pending {
    border-left: 6px solid #f59e0b;
}

.document-title {
    font-size: 16px;
    font-weight: 700;
    color: var(--text-primary);
    margin-bottom: 8px;
}

.document-media {
    position: relative;
    width: 140px;
    height: 100px;
    background: #f3f4f6;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    border: 1px solid #e5e7eb;
}

.document-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.document-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #9ca3af;
    gap: 4px;
}

.document-icon {
    font-size: 24px;
}

.document-text {
    font-size: 10px;
    text-align: center;
    padding: 0 4px;
}

.doc-overlay-icons {
    position: absolute;
    top: 4px;
    right: 4px;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.doc-multi-count {
    background: rgba(0, 0, 0, 0.6);
    color: #fff;
    font-size: 10px;
    padding: 2px 6px;
    border-radius: 10px;
}

/* Actions */
.document-actions-pending {
    display: flex;
    flex-direction: column;
    gap: 8px;
    justify-content: center;
}

.doc-btn {
    padding: 8px 16px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    min-width: 100px;
    border: none;
}

.doc-btn.accept {
    background: #000;
    color: #fff;
}

.doc-btn.accept:disabled {
    background: #d1d5db;
    cursor: not-allowed;
}

.doc-btn.reject {
    background: #f3f4f6;
    color: #374151;
}

.doc-btn.undo {
    background: transparent;
    color: #374151;
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 4px 8px;
}

.doc-btn.undo:hover {
    background: #f3f4f6;
}

/* Status States */
.document-status-accepted,
.document-status-rejected {
    display: flex;
    flex-direction: column;
    gap: 8px;
    justify-content: center;
    align-items: flex-start;
}

.status-accepted-box {
    background: #ecfdf5;
    color: #065f46;
    padding: 6px 12px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 700;
    font-size: 14px;
}

.status-rejected-box {
    background: #fef2f2;
    color: #991b1b;
    padding: 8px 12px;
    border-radius: 8px;
    display: flex;
    align-items: flex-start;
    gap: 8px;
    border: 1px solid #fee2e2;
}

.rejected-content {
    display: flex;
    flex-direction: column;
}

.rejected-title {
    font-weight: 700;
    font-size: 14px;
}

.rejected-message {
    font-size: 12px;
    opacity: 0.8;
}

/* New Documents */
.new-document-card,
.document-card-new-booking {
    padding: 24px;
    background: var(--card-bg);
    border: 1px solid var(--divider);
    border-radius: 12px;
    cursor: pointer;
    margin-bottom: 12px;
}

.new-document-content {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: flex-start;
}

.new-doc-left {
    flex: 1;
}

.new-doc-info {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.new-doc-info .document-title {
    font-size: 18px;
    font-weight: 700;
    color: var(--text-primary);
}

.new-doc-requirement {
    font-size: 16px;
    color: #4b5563;
    font-weight: 700;
}

.new-doc-hint {
    font-size: 15px;
    color: #6b7280;
}

/* Edit Mode */
.new-doc-edit-form {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
}

.new-doc-input {
    width: 100%;
    padding: 12px;
    border: 1px solid #d1d5db;
    border-radius: 12px;
    font-size: 16px;
}

.new-doc-input:focus {
    outline: none;
    border-color: #000;
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.05);
}

.new-doc-radio-group {
    display: flex;
    gap: 24px;
    margin-top: 4px;
}

.radio-label {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 16px;
    cursor: pointer;
}

.new-doc-actions {
    display: flex;
    gap: 16px;
    margin-left: 16px;
}

.doc-action-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px;
    border-radius: 8px;
    border: none;
    font-size: 16px;
    font-weight: 700;
    background: transparent;
    cursor: pointer;
    transition: all 0.2s;
}

.doc-action-btn.edit {
    color: #2563eb;
}

.doc-action-btn.delete {
    color: #dc2626;
}

.request-doc-btn-new-booking {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
    width: auto;
    padding: 18px 32px;
    background: var(--card-bg);
    border: 1px solid var(--divider);
    border-radius: 16px;
    color: var(--text-primary);
    font-size: 18px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.2s;
    margin-top: 20px;
}

.request-doc-btn-new-booking:hover:not(:disabled) {
    background: #e5e7eb;
}

.request-doc-btn-new-booking:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.save-changes-container-docs {
    margin-top: 16px;
}

.save-changes-btn {
    width: 100%;
    font-weight: 700;
    font-size: 16px;
    padding: 12px;
}

/* Status Menu */
.status-action-container {
    position: relative;
}

.status-menu {
    position: absolute;
    left: 0;
    /* align with button left */
    bottom: calc(100% + 12px);
    /* open upward with gap */
    background: var(--card-bg);
    border: 1px solid var(--divider);
    border-radius: 12px;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, .1), 0 4px 6px -2px rgba(0, 0, 0, .05);
    min-width: 180px;
    padding: 10px 14px;
    z-index: 20;
}

.status-menu-item {
    width: 100%;
    text-align: left;
    padding: 10px 6px;
    border-radius: 8px;
    background: transparent;
    border: none;
    cursor: pointer;
    color: var(--text-primary);
    font-weight: 600;
}

.status-menu-item:hover {
    background: var(--page-bg);
}

/* Form Styles */
.form-section {
    margin-bottom: 30px;
    padding-bottom: 10px;
}

.section-title {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 20px;
    color: var(--text-primary);
}

.form-label {
    display: block;
    font-weight: 600;
    color: #374151;
    margin-bottom: 10px;
}

/* Guest Counter */
.guest-counter-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 0;
    border-bottom: 1px solid #e5e7eb;
}

.guest-counter-item:last-child {
    border-bottom: none;
}

.counter-controls {
    display: flex;
    align-items: center;
    gap: 16px;
}

.counter-value {
    font-size: 16px;
    font-weight: 600;
    min-width: 30px;
    text-align: center;
}

/* Collect Documents Section */
.collect-documents-section {
    padding: 20px 0;
    border-top: 1px solid #e5e7eb;
    border-bottom: 1px solid #e5e7eb;
}

/* Document Cards */
.document-card {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 16px;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    margin-bottom: 12px;
}

.document-actions {
    display: flex;
    gap: 8px;
    flex-shrink: 0;
}

/* Room Cards */
.rooms-list {
    max-height: none;
}

.room-card {
    padding: 20px;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    margin-bottom: 16px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.room-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: #000;
}

.room-card.sold-out {
    opacity: 0.6;
    background-color: #f3f4f6;
    cursor: not-allowed;
    border-color: #e5e7eb;
}

.room-card.sold-out:hover {
    box-shadow: none;
    border-color: #e5e7eb;
}

.room-card.selected {
    border-color: #000;
    border-width: 2px;
    background-color: #f9fafb;
}

.room-features {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 12px;
}

/* Room Options List */
.room-options-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.room-option-card {
    padding: 20px;
    border: 2px solid #e5e7eb;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.room-option-card:hover {
    border-color: #000;
}

.room-option-card.selected {
    border-color: #000;
    background-color: #f9fafb;
}

.radio-indicator {
    width: 24px;
    height: 24px;
    border: 2px solid #d1d5db;
    border-radius: 50%;
    position: relative;
    transition: all 0.2s ease;
}

.radio-indicator.active {
    border-color: #000;
}

.radio-indicator.active::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
    background-color: #000;
    border-radius: 50%;
}

/* Summary Card */
.summary-card {
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 20px;
}

.summary-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid #e5e7eb;
}

.summary-item:last-child {
    border-bottom: none;
}

.summary-label {
    font-weight: 600;
    color: var(--text-secondary);
}

.summary-value {
    font-weight: 600;
    color: var(--text-primary);
}

/* Payment Breakdown */
.payment-breakdown {
    background: var(--page-bg);
    border: 1px solid var(--divider);
    border-radius: 12px;
    padding: 20px;
}

.payment-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid #e5e7eb;
}

.payment-item:last-child {
    border-bottom: none;
}

.payment-item.total {
    padding-top: 16px;
    margin-top: 8px;
    border-top: 2px solid #000;
    font-size: 18px;
}

/* Document Card Styles for New Booking */
.documents-grid-new-booking {
    display: grid;
    grid-template-columns: 1fr;
    gap: 18px;
    margin-bottom: 16px;
}

.document-card-new-booking {
    border: 1px solid var(--divider);
    background: var(--card-bg);
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0;
    padding: 20px;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.document-card-new-booking:hover {
    border-color: #d1d5db;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.new-document-content {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
    gap: 16px;
}

.new-doc-left {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.new-doc-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.document-title {
    font-size: 16px;
    font-weight: 700;
    color: #111;
    margin: 0;
}

.new-doc-requirement {
    font-weight: 600;
    font-size: 15px;
    color: #111;
    margin: 0;
}

.new-doc-hint {
    font-size: 15px;
    color: #374151;
    margin: 0;
}

.new-doc-edit-form {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
}

.new-doc-input {
    width: 100%;
    padding: 10px 14px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 500;
    color: #111;
}

.new-doc-input:focus {
    outline: none;
    border-color: rgba(var(--vs-primary), 1);
}

.new-doc-radio-group {
    display: flex;
    gap: 16px;
    align-items: center;
}

.radio-label {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-size: 15px;
    color: #111;
    font-weight: 500;
}

.radio-input {
    width: 18px;
    height: 18px;
    cursor: pointer;
}

.new-doc-actions {
    display: flex;
    align-items: center;
    gap: 16px;
}

.doc-action-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    font-size: 15px;
    font-weight: 600;
    color: #2563eb;
    transition: color 0.2s ease;
}

/* View Details Button */
.view_details {
    padding: 0 16px;
}


.doc-action-btn:hover {
    color: #1d4ed8;
}

.doc-action-btn.delete {
    color: #dc2626;
}

.doc-action-btn.delete:hover {
    color: #b91c1c;
}

/* Request New Document Button */
.request-doc-btn-new-booking {
    display: flex;
    align-items: center;
    gap: 8px;
    background: var(--card-bg);
    border: 1px solid var(--divider);
    border-radius: 12px;
    padding: 26px 28px;
    font-size: 16px;
    font-weight: 700;
    color: var(--text-primary);
    cursor: pointer;
    transition: all 0.2s ease;
    justify-content: start;
}

.request-doc-btn-new-booking:hover {
    background: var(--page-bg);
}

.request-doc-btn-new-booking svg {
    color: var(--text-primary);
}

.request-doc-btn-new-booking:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* Premium Room Options Styles */
.options-horizontal-scroll {
    display: flex;
    overflow-x: auto;
    gap: 16px;
    padding: 4px 4px 16px 4px;
    scrollbar-width: thin;
}

.options-horizontal-scroll::-webkit-scrollbar {
    height: 6px;
}

.options-horizontal-scroll::-webkit-scrollbar-thumb {
    background: #e2e8f0;
    border-radius: 10px;
}

.option-card-premium {
    min-width: 290px;
    max-width: 290px;
    border: 1.5px solid var(--divider);
    border-radius: 16px;
    padding: 24px;
    background: var(--card-bg);
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
}

.option-card-premium.selected {
    border-color: #16a34a;
    background: #f0fdf4;
    box-shadow: 0 0 0 2px rgba(22, 163, 74, 0.25);
}

.option-card-premium.selected .option-main-title {
    color: #166534;
}

.option-card-header {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 20px;
}

.radio-indicator-premium {
    width: 22px;
    height: 22px;
    border: 2px solid #ccc;
    border-radius: 50%;
    flex-shrink: 0;
    margin-top: 2px;
    position: relative;
    transition: all 0.2s ease;
}

.radio-indicator-premium.active {
    border-color: #16a34a;
    background: #dcfce7;
}

.radio-indicator-premium.active::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
    background-color: #16a34a;
    border-radius: 50%;
}

.option-title-group {
    display: flex;
    flex-direction: column;
}

.option-label {
    font-size: 14px;
    font-weight: 700;
    color: var(--text-primary);
}

.option-main-title {
    font-size: 19px;
    font-weight: 800;
    color: var(--text-primary);
    margin: 2px 0 0 0;
    line-height: 1.2;
}

.option-features {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-bottom: 24px;
}

.feature-item {
    font-size: 15px;
    color: var(--text-secondary);
    font-weight: 500;
}

.read-more-link {
    font-size: 15px;
    font-weight: 700;
    color: var(--text-primary);
    text-decoration: underline;
    margin-top: 4px;
}

.option-price-section {
    margin-top: auto;
}

.option-price {
    font-size: 22px;
    font-weight: 800;
    color: var(--text-primary);
}

.option-taxes {
    font-size: 14px;
    color: var(--text-secondary);
    font-weight: 500;
}

/* Room Card V2 (Image Style) */
.room-card-v2 {
    background: var(--card-bg);
    border: 1px solid var(--divider);
    border-radius: 24px;
    margin-bottom: 24px;
    overflow: hidden;
    transition: all 0.3s ease;
}

.room-card-v2.selected {
    border-color: #16a34a;
    background: #f0fdf4;
    box-shadow: 0 0 0 3px rgba(22, 163, 74, 0.18);
}

.room-selected-badge {
    display: inline-flex;
    align-items: center;
    padding: 4px 12px;
    border-radius: 999px;
    background: #16a34a;
    color: #fff;
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 0.02em;
    text-transform: uppercase;
}

.room-card-v2.sold-out {
    opacity: 0.7;
    filter: grayscale(0.5);
}

.room-card-inner {
    padding: 24px;
}

.room-title-v2 {
    font-size: 28px;
    font-weight: 800;
    color: var(--text-primary);
    margin: 0;
    line-height: 1.2;
}

.share-btn-circular {
    width: 44px;
    height: 44px;
    background: var(--page-bg);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.2s ease;
}

.share-btn-circular:hover {
    background: #e5e7eb;
}

.room-availability-red {
    color: #e11d48;
    font-weight: 700;
    font-size: 16px;
    margin: 0;
}

.room-availability-gray {
    color: #6b7280;
    font-weight: 700;
    font-size: 16px;
    margin: 0;
}

.room-image-container-v2 {
    width: 100%;
    height: 220px;
    border-radius: 20px;
    overflow: hidden;
    background: #f3f4f6;
}

.room-image-v2 {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.room-image-placeholder-v2 {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.pricing-section-v2 {
    display: flex;
    align-items: baseline;
    gap: 8px;
}

.price-strikethrough-v2 {
    font-size: 22px;
    font-weight: 800;
    color: var(--text-primary);
    text-decoration: line-through;
    opacity: 0.9;
}

.price-main-v2 {
    font-size: 28px;
    font-weight: 800;
    color: var(--text-primary);
}

.price-period-v2 {
    font-size: 18px;
    font-weight: 700;
    color: var(--text-primary);
}

.taxes-label-v2 {
    font-size: 16px;
    color: #4b5563;
    font-weight: 600;
}

.trust-badges-container-v2 {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.trust-badge-item {
    display: flex;
    align-items: center;
    font-size: 17px;
    font-weight: 600;
    color: var(--text-primary);
}

.stroke-3 {
    stroke-width: 3px;
}

.selection-action-v2 {
    width: 100%;
}

.select-room-btn-v2 {
    width: 100%;
    background: var(--neutral-invert);
    color: var(--page-bg);
    border: none;
    border-radius: 14px;
    padding: 16px;
    font-size: 18px;
    font-weight: 700;
    cursor: pointer;
    transition: transform 0.2s ease;
}

.select-room-btn-v2:active {
    transform: scale(0.98);
}

.select-room-btn-v2:disabled {
    background: #9ca3af;
    cursor: not-allowed;
}

.quantity-selector-v2 {
    display: flex;
    align-items: center;
    background: #14532d;
    border: 2px solid #16a34a;
    border-radius: 14px;
    overflow: hidden;
    height: 56px;
    box-shadow: 0 0 0 3px rgba(22, 163, 74, 0.15);
}

.qty-btn-v2 {
    width: 56px;
    height: 100%;
    background: transparent;
    border: none;
    color: #fff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s ease;
}

.qty-btn-v2:hover {
    background: rgba(255, 255, 255, 0.1);
}

.qty-btn-v2.disabled {
    opacity: 0.3;
    cursor: not-allowed;
}

.qty-value-v2 {
    flex: 1;
    text-align: center;
    color: #fff;
    font-size: 20px;
    font-weight: 700;
}

/* Amenities V2 Styles */
.amenities-container-v2 {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.amenity-tag-v2 {
    display: flex;
    align-items: center;
    gap: 6px;
    background: var(--page-bg);
    padding: 6px 12px;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 700;
    color: var(--text-primary);
    border: 1px solid var(--divider);
}

.amenity-tag-v2 svg {
    color: var(--text-primary);
    stroke-width: 3px;
}

/* Cancellation refund modal */
.cancellation-refund-panel {
    margin-bottom: 20px;
}

.refund-summary-card,
.refund-presets {
    margin-bottom: 16px;
}

.refund-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 15px;
    margin-bottom: 8px;
}

.refund-row-highlight {
    padding: 14px 16px;
    background: #f0fdf4;
    border: 1px solid #86efac;
    border-radius: 12px;
    margin-top: 12px;
}

.refund-amount {
    color: #166534;
    font-size: 18px;
}

.refund-hint {
    font-size: 13px;
    color: #6b7280;
    margin-top: 8px;
}

.refund-presets {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.refund-preset-btn {
    border: 1px solid var(--divider);
    background: var(--card-bg);
    color: var(--text-primary);
    border-radius: 999px;
    padding: 8px 12px;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
}

.refund-preset-btn:hover {
    background: #f9fafb;
}

.refund-preset-btn.active {
    background: #14532d;
    border-color: #14532d;
    color: #fff;
    box-shadow: 0 0 0 3px rgba(22, 163, 74, 0.18);
}

.refund-field-label {
    display: block;
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 8px;
    color: #374151;
}

.refund-input {
    width: 100%;
    border: 1px solid var(--divider);
    border-radius: 12px;
    padding: 12px 14px;
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 8px;
    background: var(--page-bg);
    color: var(--text-primary);
}

/* Reason Modal Styles */
.reason-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99999;
    padding: 20px;
}

.reason-modal {
    background: var(--card-bg);
    color: var(--text-primary);
    border-radius: 16px;
    max-width: 540px;
    width: 100%;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
    overflow: hidden;
}

.reason-modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 24px 16px 24px;
    border-bottom: 1px solid var(--divider);
    background: var(--card-bg);
    color: var(--text-primary);
}

.reason-modal-title {
    font-size: 20px;
    font-weight: 700;
    color: #111827;
    margin: 0;
}

.reason-modal-close {
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #6b7280;
    transition: color 0.2s ease;
}

.reason-modal-close:hover {
    color: #111827;
}

.reason-modal-body {
    padding: 24px;
}

.reason-modal-description {
    font-size: 14px;
    color: #6b7280;
    margin: 0 0 16px 0;
    line-height: 1.5;
}

.reason-textarea {
    width: 100%;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    padding: 12px;
    font-size: 14px;
    font-family: inherit;
    resize: vertical;
    min-height: 120px;
    transition: border-color 0.2s ease;
}

.reason-textarea:focus {
    outline: none;
    border-color: #000;
}

.reason-textarea::placeholder {
    color: #9ca3af;
}

.reason-modal-footer {
    display: flex;
    gap: 12px;
    padding: 16px 24px 24px 24px;
}

.reason-btn-cancel,
.reason-btn-confirm {
    flex: 1;
    padding: 12px 24px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    border: none;
}

.reason-btn-cancel {
    background: var(--card-bg);
    color: var(--text-primary);
}

.reason-btn-cancel:hover {
    background: var(--page-bg);
}

.reason-btn-confirm {
    background: var(--neutral-invert);
    color: var(--page-bg);
}

.reason-btn-confirm:hover {
    opacity: 0.9;
}

.reason-btn-confirm:active {
    transform: scale(0.98);
}

.theme-dark .sarai-bookings-page .text-black,
.theme-dark .sarai-bookings-page .text-gray-800 {
    color: var(--text-primary) !important;
}

.theme-dark .sarai-bookings-page .text-gray-500,
.theme-dark .sarai-bookings-page .text-gray-600 {
    color: var(--text-secondary) !important;
}

.theme-dark .sarai-bookings-page .bg-white,
.theme-dark .sarai-bookings-page .bg-gray-50 {
    background-color: var(--card-bg) !important;
}

.theme-dark .sarai-bookings-page .bg-gray-200 {
    background-color: var(--page-bg) !important;
}

.theme-dark .document-media,
.theme-dark .room-image-container-v2,
.theme-dark .document-media {
    background: var(--page-bg);
    border-color: var(--divider);
}

.theme-dark .doc-btn.reject,
.theme-dark .doc-btn.undo {
    background: var(--card-bg);
    color: var(--text-primary);
}

.theme-dark .doc-btn.accept {
    background: var(--neutral-invert);
    color: var(--page-bg);
}

.theme-dark .tag:not(.warning):not(.danger):not(.success) {
    background: var(--card-bg);
    color: var(--text-primary);
}

.theme-dark .option-card-premium.selected,
.theme-dark .room-card-v2.selected {
    background: var(--green-bg) !important;
}

.theme-dark .taxes-label-v2,
.theme-dark .room-availability-gray,
.theme-dark .new-doc-requirement {
    color: var(--text-secondary);
}
</style>
